{
  "common": {
    "loading": "加载中...",
    "error": "错误",
    "retry": "重试",
    "cancel": "取消",
    "save": "保存",
    "saving": "保存中...",
    "close": "关闭",
    "back": "返回",
    "next": "下一步",
    "search": "搜索",
    "watchNow": "立即观看",
    "playNow": "立即播放",
    "play": "播放",
    "moreInfo": "更多信息",
    "seeAll": "查看全部",
    "new": "新",
    "live": "直播",
    "recommended": "推荐",
    "edit": "编辑",
    "delete": "删除",
    "add": "添加",
    "enabled": "已启用",
    "disabled": "已禁用",
    "invalidDate": "无效日期",
    "appName": "🏠 Bayit+",
    "appVersion": "🏠 Bayit+ v1.0.0",
    "slogan": "您的家，随处可及。",
    "ok": "确定",
    "success": "成功",
    "warning": "警告",
    "confirm": "确认",
    "yes": "是",
    "no": "否",
    "apply": "应用",
    "errors": {
      "unexpected": "发生意外错误"
    },
    "send": "发送",
    "done": "完成",
    "all": "全部",
    "reset": "重置",
    "deleting": "删除中...",
    "noResults": "未找到结果",
    "tryDifferentSearch": "尝试不同的搜索词",
    "previous": "上一个",
    "actions": "操作",
    "pageOf": "第 {{page}} 页，共 {{total}} 页",
    "noData": "暂无数据",
    "filters": "筛选",
    "clear": "清除",
    "clearSelection": "清除",
    "expand": "展开",
    "collapse": "收起",
    "upgrade": "升级到高级版",
    "skip": "跳过",
    "thisContent": "[zh] this content",
    "backToHome": "[zh] Back to Home",
    "dismiss": "[zh] Dismiss",
    "goBack": "[zh] Go Back",
    "pause": "[zh] Pause",
    "tryAgain": "[zh] Try Again",
    "refresh": "刷新"
  },
  "culturalContext": {
    "loading": "正在加载说明...",
    "loadError": "加载说明失败",
    "related": "相关参考"
  },
  "demo": {
    "banner": "演示模式",
    "bannerSubtext": "使用模拟数据 - 无API调用",
    "days": {
      "sunday": "星期日",
      "monday": "星期一",
      "tuesday": "星期二",
      "wednesday": "星期三",
      "thursday": "星期四",
      "friday": "星期五",
      "saturday": "星期六"
    },
    "shabbat": "安息日",
    "until_shabbat": "距安息日",
    "search_interpretation": "搜索 \"{{query}}\"",
    "suggestions": {
      "0": "法乌达",
      "1": "施蒂塞尔",
      "2": "德黑兰",
      "3": "仲裁者",
      "4": "劳动"
    },
    "premium_plan": "高级版",
    "assistant_response": "我推荐《法乌达》- 一部优秀的惊悚剧集！",
    "morning_greeting": "早上好！今天天气不错，以色列有一些重要新闻，我为您精选了一些内容。"
  },
  "hero": {
    "watch": "观看",
    "moreInfo": "更多信息",
    "addToList": "添加到列表"
  },
  "login": {
    "title": "欢迎回来",
    "subtitle": "登录以继续使用 Bayit+",
    "tagline": "美国的您的家",
    "email": "电子邮件",
    "emailPlaceholder": "输入您的电子邮件",
    "password": "密码",
    "passwordPlaceholder": "输入您的密码",
    "submit": "登录",
    "loggingIn": "登录中...",
    "or": "或",
    "forgotPassword": "忘记密码？",
    "continueWithGoogle": "使用 Google 继续",
    "noAccount": "没有账户？",
    "signUp": "注册",
    "register": "注册",
    "name": "姓名",
    "termsNotice": "登录即表示您同意我们的服务条款和隐私政策",
    "errors": {
      "emailRequired": "需要电子邮件",
      "passwordRequired": "需要密码",
      "loginFailed": "登录失败。请检查您的凭据。",
      "googleFailed": "Google 登录失败。请重试。",
      "fillAllFields": "请填写所有字段"
    },
    "qrInstructions": "用手机扫描二维码快速登录",
    "methodQR": "二维码",
    "methodVoice": "语音",
    "methodTraditional": "邮箱",
    "qrTitle": "扫码登录",
    "qrDescription": "用手机扫描此二维码即可免输入登录",
    "expiresIn": "5分钟后过期",
    "companionConnected": "手机已连接！",
    "authenticating": "正在登录...",
    "sessionExpired": "会话已过期",
    "refreshQR": "生成新二维码",
    "generatingQR": "正在生成二维码...",
    "howItWorks": "使用方法：",
    "step1": "在手机上打开相机",
    "step2": "扫描上方的二维码",
    "step3": "在手机上登录",
    "step4": "电视自动登录！",
    "voicePlaceholder": "输入您的回复...",
    "send": "发送",
    "createAccount": "创建账户",
    "bayitThinking": "Bayit 正在思考...",
    "unexpectedError": "发生意外错误"
  },
  "tvLogin": {
    "invalidQR": "无效的二维码。请从电视重新扫描。",
    "sessionInvalid": "此二维码已过期。请在电视上生成新的。",
    "verificationFailed": "验证会话失败。请重试。",
    "fillAllFields": "请填写所有字段",
    "loginFailed": "登录失败。请检查您的凭据。",
    "notLoggedIn": "您尚未在此设备上登录。",
    "enterCredentials": "请输入您的凭据以授权您的电视。",
    "authFailed": "授权失败。",
    "verifying": "验证中...",
    "verifyingDescription": "正在连接到您的电视...",
    "loginTitle": "登录您的电视",
    "loginDescription": "输入您的凭据以授权您的电视",
    "authorizing": "授权中...",
    "authorizingDescription": "正在登录您的电视...",
    "authorizeTV": "授权电视",
    "success": "成功！",
    "successDescription": "您的电视现已登录。您可以关闭此页面。",
    "goToHome": "返回首页",
    "error": "出现问题",
    "tryAgain": "重试",
    "securityNote": "您的凭据安全发送，绝不存储在电视上。",
    "footer": "遇到问题？请确保您扫描的是电视上最新生成的二维码。",
    "almostThere": "[zh] Almost there!",
    "authenticating": "[zh] Authenticating...",
    "connected": "[zh] Connected",
    "expired": "[zh] Code Expired",
    "expiredMessage": "[zh] Your sign-in code has expired. Please request a new one.",
    "header": "[zh] Sign In to TV",
    "pleaseSignIn": "[zh] Please sign in on your phone or computer",
    "signInButton": "[zh] Sign In",
    "signInToTV": "[zh] Sign In to TV",
    "subtitle": "[zh] Enter the code shown on your TV screen",
    "tvSignedIn": "[zh] TV signed in successfully"
  },
  "googleLogin": {
    "cancelledError": "Google 登录已取消",
    "missingCode": "缺少认证码",
    "loginError": "Google 登录出错",
    "redirecting": "正在跳转到登录页面...",
    "connecting": "正在连接 Google..."
  },
  "register": {
    "title": "创建账户",
    "subtitle": "加入 Bayit+ 观看您喜爱的内容",
    "name": "全名",
    "namePlaceholder": "张三",
    "email": "电子邮件",
    "emailPlaceholder": "your@email.com",
    "password": "密码",
    "passwordPlaceholder": "至少8个字符",
    "confirmPassword": "确认密码",
    "confirmPasswordPlaceholder": "再次输入密码",
    "submit": "注册",
    "registering": "注册中...",
    "acceptTerms": "我同意",
    "termsOfService": "服务条款",
    "and": "和",
    "privacyPolicy": "隐私政策",
    "continueWithGoogle": "使用 Google 注册",
    "haveAccount": "已有账户？",
    "signIn": "登录",
    "fullName": "全名",
    "loginLink": "登录",
    "placeholders": {
      "fullName": "张三",
      "email": "your@email.com",
      "password": "至少8个字符",
      "confirmPassword": "再次输入密码"
    },
    "errors": {
      "nameRequired": "需要姓名",
      "emailRequired": "需要电子邮件",
      "passwordRequired": "需要密码",
      "passwordTooShort": "密码至少需要8个字符",
      "passwordMismatch": "密码不匹配",
      "acceptTerms": "您必须接受服务条款和隐私政策",
      "fillAllFields": "请填写所有字段",
      "registrationFailed": "注册失败。请重试。",
      "googleFailed": "Google 注册失败。请重试。"
    }
  },
  "nav": {
    "home": "首页",
    "vod": "点播",
    "liveTV": "直播电视",
    "epg": "节目指南",
    "radio": "广播",
    "podcasts": "播客",
    "flows": "流程",
    "judaism": "犹太教",
    "children": "儿童",
    "profile": "个人资料",
    "search": "搜索",
    "settings": "设置",
    "favorites": "收藏",
    "watchlist": "观看列表",
    "downloads": "下载",
    "recordings": "我的录制",
    "widgets": "小组件",
    "help": "帮助与支持",
    "discover": "发现",
    "account": "账户",
    "subscribe": "订阅",
    "plans": "[zh] Plans",
    "admin": "管理",
    "games": "游戏",
    "friends": "好友",
    "glossary": "词汇表",
    "missions": "任务",
    "audiobooks": "有声书",
    "playlist": "播放列表",
    "zehAniHub": "泽·阿尼",
    "support": "支持",
    "discoverHub": "发现AI",
    "listen": "收听",
    "byoc": "我的来源",
    "household": "家庭",
    "messages": "消息",
    "myContent": "我的内容",
    "social": "社交"
  },
  "epg": {
    "title": "电视指南",
    "subtitle": "浏览直播电视节目时间表",
    "gridView": "网格视图",
    "listView": "列表视图",
    "israelTime": "以色列时间",
    "localTime": "本地时间",
    "il": "以色列",
    "local": "本地",
    "jumpToNow": "跳到现在",
    "goBack": "← {{hours}}小时",
    "goForward": "{{hours}}小时 →",
    "toggleTimezone": "切换时区",
    "errorTitle": "加载电视指南失败",
    "errorLoading": "无法加载电视指南数据",
    "noPrograms": "未找到节目",
    "noChannels": "无可用频道",
    "recordProgram": "录制节目",
    "channel": "频道",
    "enableSubtitles": "启用字幕",
    "subtitleLanguage": "字幕语言",
    "storageEstimate": "存储估计",
    "availableSpace": "可用空间",
    "lowStorage": "存储空间不足警告",
    "lowStorageMessage": "您的存储空间不足。请考虑删除旧录制。",
    "scheduleRecording": "定时录制",
    "scheduledRecordingNotSupported": "暂不支持定时录制。仅支持即时录制。",
    "recordingFailed": "启动/定时录制失败",
    "smartSearch": "智能搜索",
    "smartSearchSubtitle": "用自然语言提问",
    "smartSearchPlaceholder": "例如：今晚有哪些塔莉·莎朗主演的节目",
    "searchPlaceholder": "搜索节目、频道、演员...",
    "premiumRequired": "高级功能",
    "premiumRequiredMessage": "智能搜索使用 AI 理解您的问题。升级到高级版以使用此功能。",
    "searchWithAI": "AI 搜索",
    "searching": "搜索中...",
    "tryThese": "试试这些示例",
    "exampleQuery1": "今晚有哪些塔莉·莎朗主演的节目",
    "exampleQuery2": "本周有哪些喜剧节目？",
    "exampleQuery3": "在11频道找历史纪录片",
    "exampleQuery4": "明天早上有哪些新闻节目",
    "aiDisclaimer": "由 Claude AI 提供支持。结果可能因节目数据可用性而异。",
    "interpretationTitle": "我理解的内容",
    "noResultsFound": "未找到匹配您查询的节目"
  },
  "home": {
    "continueWatching": "继续观看",
    "featuredContent": "精选",
    "liveTV": "直播电视",
    "allChannels": "所有频道",
    "liveChannels": "直播频道",
    "showOnlyWithSubtitles": "仅显示有字幕的",
    "israeliMovies": "以色列电影",
    "israeli-movies": "以色列电影",
    "israeli-series": "以色列剧集",
    "action": "动作与惊悚",
    "comedy": "喜剧",
    "drama": "剧情",
    "documentaries": "纪录片",
    "loadingContent": "加载内容中...",
    "liveNow": "正在直播",
    "trendingInIsrael": "以色列热门",
    "jerusalemConnection": "耶路撒冷连接",
    "telAvivConnection": "特拉维夫连接",
    "categories": "分类",
    "nearYou": "附近的以色列人",
    "betaExclusive": "Beta专属",
    "carousel": {
      "fauda": {
        "title": "法乌达",
        "subtitle": "第4季 - 正在播出",
        "description": "热门以色列剧集第四季回归，充满悬疑与动作"
      },
      "shtisel": {
        "title": "施蒂塞尔",
        "subtitle": "全季可看",
        "description": "跟随耶路撒冷极端正统社区的施蒂塞尔家族"
      },
      "tehran": {
        "title": "德黑兰",
        "subtitle": "第2季",
        "description": "摩萨德特工深入伊朗执行危险任务"
      },
      "live": {
        "title": "直播 - Kan 11",
        "subtitle": "立即观看",
        "description": "新闻、时事和优质内容"
      }
    },
    "enableLocation": "[zh] Enable Location",
    "locationPermissionDeniedDescription": "[zh] Location access was denied. Enable it in Settings to see content near you.",
    "locationPermissionDescription": "[zh] Allow location access to discover content near you.",
    "openSettings": "[zh] Open Settings"
  },
  "search": {
    "title": "搜索",
    "subtitle": "查找电影、剧集、频道、电台和播客",
    "placeholder": "搜索内容...",
    "voicePlaceholder": "请说话...",
    "searching": "搜索中...",
    "listening": "正在听...",
    "noResults": "未找到结果",
    "noResultsHint": "尝试不同的关键词或更改筛选条件",
    "tryDifferent": "尝试不同的搜索词",
    "resultsFor": "的结果",
    "resultsFound": "为 \"{{query}}\" 找到 {{count}} 个结果",
    "recentSearches": "最近搜索",
    "clearAll": "清除全部",
    "trending": "热门搜索",
    "promptTitle": "您在找什么？",
    "promptDescription": "搜索您喜欢的内容或使用语音搜索",
    "filters": {
      "all": "全部",
      "vod": "电影与剧集",
      "live": "频道",
      "radio": "广播",
      "podcast": "播客",
      "moviesAndSeries": "电影与剧集",
      "channels": "频道",
      "podcasts": "播客"
    },
    "suggestions": {
      "movies": "电影",
      "series": "剧集",
      "liveTV": "直播电视",
      "news": "新闻",
      "sports": "体育",
      "kids": "儿童"
    }
  },
  "liveTV": {
    "title": "直播电视",
    "channels": "频道",
    "nowPlaying": "正在播放",
    "loadError": "加载频道失败",
    "categories": {
      "all": "全部",
      "news": "新闻",
      "sports": "体育",
      "entertainment": "娱乐",
      "kids": "儿童",
      "documentary": "纪录片"
    }
  },
  "listen": {
    "title": "收听",
    "subtitle": "广播、播客和有声书",
    "tab": {
      "radio": "广播",
      "podcasts": "播客",
      "audiobooks": "有声书"
    }
  },
  "radio": {
    "title": "广播",
    "categories": {
      "all": "全部",
      "music": "音乐",
      "news": "新闻",
      "talk": "谈话",
      "jewish": "犹太"
    },
    "noStations": "无可用电台",
    "tryLater": "请稍后重试",
    "playing": "播放中",
    "fmSuffix": "FM"
  },
  "podcasts": {
    "title": "播客",
    "episodes": "集",
    "categories": {
      "all": "全部",
      "general": "综合",
      "news": "新闻",
      "politics": "政治",
      "tech": "科技",
      "business": "商业",
      "jewish": "犹太",
      "entertainment": "娱乐",
      "sports": "体育",
      "history": "历史",
      "educational": "教育"
    },
    "noPodcasts": "无可用播客",
    "tryLater": "请稍后重试",
    "playLatest": "[zh] Play Latest"
  },
  "vod": {
    "title": "电影与剧集",
    "movies": "电影",
    "series": "剧集",
    "searchPlaceholder": "搜索电影和剧集...",
    "noMovies": "未找到电影",
    "noSeries": "未找到剧集",
    "loadError": "加载内容失败",
    "showOnlyWithSubtitles": "仅显示有字幕的",
    "categories": {
      "all": "全部",
      "drama": "剧情",
      "comedy": "喜剧",
      "action": "动作",
      "documentary": "纪录片",
      "kids": "儿童"
    },
    "allCategories": "全部",
    "emptyTitle": "无可用内容",
    "emptyDescription": "请选择其他分类",
    "allContent": "[zh] All Content",
    "noContent": "[zh] No content available",
    "noContentInCategory": "[zh] No content found in this category"
  },
  "account": {
    "title": "我的账户",
    "profile": "个人资料",
    "settings": "设置",
    "subscription": "订阅",
    "manageSubscription": "管理订阅",
    "personalDetails": "个人信息",
    "billing": "账单与付款",
    "logout": "退出登录",
    "login": "登录",
    "register": "注册",
    "email": "电子邮件",
    "password": "密码",
    "name": "姓名",
    "guest": "访客",
    "premium": "高级版",
    "basic": "基础版"
  },
  "flows": {
    "title": "流程",
    "subtitle": "每个时刻的个性化内容体验",
    "activeNow": "正在进行",
    "start": "开始",
    "skipToday": "今天跳过",
    "systemFlows": "现成流程",
    "customFlows": "我的流程",
    "system": "系统",
    "noCustomFlows": "暂无自定义流程",
    "createHint": "创建您的第一个个性化流程",
    "createCustom": "创建自定义流程",
    "createFlow": "创建流程",
    "editFlow": "编辑流程",
    "type": "类型",
    "systemFlow": "系统流程",
    "customFlow": "自定义流程",
    "schedule": "时间表",
    "content": "内容",
    "items": "项目",
    "aiGenerated": "AI 生成",
    "autoPlay": "自动播放",
    "aiEnabled": "AI 策展",
    "shabbatTrigger": "安息日夜晚",
    "manual": "手动",
    "flowName": "流程名称",
    "flowNamePlaceholder": "例如：我的早间例程",
    "description": "描述",
    "descriptionPlaceholder": "这个流程是做什么的？",
    "startTime": "开始时间",
    "endTime": "结束时间",
    "actions": "操作",
    "details": "详情",
    "createFlowDesc": "设计您的个性化内容体验",
    "editFlowDesc": "更新您的流程设置和内容",
    "basicInfo": "基本信息",
    "options": "选项",
    "autoPlayDesc": "当前项目结束时自动播放下一个",
    "aiEnabledDesc": "让 AI 根据您的偏好策展内容",
    "startFlow": "开始流程",
    "deleteFlow": "删除流程",
    "custom": "自定义",
    "morning": "早晨",
    "evening": "晚间",
    "shabbat": "安息日",
    "addContent": "添加内容",
    "contentPicker": {
      "title": "添加内容到流程",
      "tabs": {
        "live": "直播电视",
        "radio": "广播",
        "vod": "点播",
        "podcast": "播客"
      },
      "search": "搜索内容...",
      "selected": "已选 {{count}} 个",
      "addSelected": "添加所选",
      "noResults": "未找到内容",
      "alreadyAdded": "已在流程中",
      "loadMore": "加载更多"
    },
    "flowItems": {
      "title": "流程内容",
      "empty": "暂无内容。点击添加内容开始。",
      "count": "{{count}} 个项目",
      "remove": "移除",
      "moveUp": "上移",
      "moveDown": "下移",
      "order": "排序",
      "confirmRemove": "再次点击确认移除",
      "maxReached": "最多 {{max}} 个项目",
      "more": "更多项目"
    },
    "days": {
      "sunday": "星期日",
      "monday": "星期一",
      "tuesday": "星期二",
      "wednesday": "星期三",
      "thursday": "星期四",
      "friday": "星期五",
      "saturday": "星期六",
      "sundayShort": "周日",
      "mondayShort": "周一",
      "tuesdayShort": "周二",
      "wednesdayShort": "周三",
      "thursdayShort": "周四",
      "fridayShort": "周五",
      "saturdayShort": "周六",
      "selectAll": "全选",
      "deselectAll": "取消全选",
      "title": "生效日期",
      "everyday": "每天",
      "everyDay": "每天",
      "weekdays": "工作日",
      "weekends": "周末",
      "noneSelected": "未选择日期",
      "selectedCount": "已选 {{count}} 天"
    },
    "trigger": {
      "type": "触发类型",
      "time": "基于时间",
      "shabbat": "安息日夜晚",
      "holiday": "节日",
      "skipShabbat": "安息日跳过",
      "skipShabbatDesc": "周五晚或周六不运行此流程",
      "shabbatOffset": "点蜡烛前多少分钟",
      "shabbatOffsetDesc": "安息日前多少分钟开始此流程？",
      "calculatedTime": "计算时间",
      "thisWeek": "本周：{{day}} {{time}}",
      "comingSoon": "节日触发即将推出",
      "locationBased": "时间基于您的位置"
    },
    "examples": {
      "title": "示例流程",
      "subtitle": "点击用作模板",
      "morningRoutine": {
        "name": "早间例程",
        "desc": "以新闻、天气和振奋人心的内容开始新的一天"
      },
      "eveningWindDown": {
        "name": "晚间放松",
        "desc": "用舒缓的音乐和轻松的娱乐放松身心"
      },
      "shabbatPrep": {
        "name": "安息日准备",
        "desc": "用特别的内容为安息日营造氛围"
      },
      "coffeeBreak": {
        "name": "咖啡时光",
        "desc": "短暂休息时的快速娱乐"
      },
      "sunsetVibes": {
        "name": "日落时光",
        "desc": "周末用音乐和环境内容放松"
      }
    },
    "aiBrief": "AI 简报",
    "aiBriefDesc": "在流程开始前获取个性化的 AI 生成摘要",
    "aiBriefEnabled": "AI 简报已启用",
    "validation": {
      "nameRequired": "流程名称为必填项",
      "startTimeRequired": "开始时间为必填项",
      "endTimeRequired": "结束时间为必填项",
      "timeRange": "结束时间必须晚于开始时间",
      "daysRequired": "请至少选择一天",
      "contentRequired": "请添加内容或启用 AI"
    },
    "tv": {
      "useCompanion": "如需完整自定义功能，请使用手机上的 Bayit+ 应用或访问 bayit.plus。"
    }
  },
  "profile": {
    "title": "我的资料",
    "profileDetails": "资料详情",
    "name": "姓名",
    "notSet": "未设置",
    "email": "电子邮件",
    "editProfile": "编辑资料",
    "notificationSettings": "通知设置",
    "security": "安全",
    "changePassword": "更改密码",
    "updatePassword": "更新您的密码",
    "connectedDevices": "已连接设备",
    "manageDevices": "管理连接到您账户的设备",
    "twoFactorAuth": "双重认证",
    "addExtraSecurity": "添加额外的安全层",
    "address": {
      "line1": "123 主街",
      "line2": "特拉维夫，以色列 6100000"
    },
    "free": "免费",
    "premiumPrice": "$7.99/月",
    "familyPrice": "$12.99/月",
    "remaining": "剩余",
    "tabs": {
      "personal": "个人",
      "overview": "概览",
      "subscription": "订阅",
      "notifications": "通知",
      "security": "安全",
      "ai": "AI与语音",
      "voice": "语音与无障碍"
    },
    "subscription": {
      "currentPlan": "当前套餐",
      "renewsOn": "续订日期",
      "manageSubscription": "管理订阅",
      "cancelSubscription": "取消订阅",
      "noActivePlan": "无活跃订阅",
      "selectPlan": "选择套餐"
    },
    "notifications": "通知",
    "ai": {
      "title": "AI与个性化",
      "description": "配置 AI 功能",
      "assistant": "AI 助手",
      "assistantDesc": "个性化推荐和帮助",
      "chatbot": "AI 助手",
      "chatbotEnabled": "启用 AI 助手",
      "chatbotEnabledDesc": "获取内容导航帮助",
      "saveHistory": "保存对话历史",
      "saveHistoryDesc": "记住之前的对话",
      "recommendations": "推荐",
      "personalizedRecs": "个性化推荐",
      "personalizedRecsDesc": "基于历史的内容建议",
      "privacy": "隐私与数据",
      "privacyDesc": "您的数据已加密且安全",
      "dataConsent": "使用分析",
      "dataConsentDesc": "帮助改进 AI 功能",
      "privacyNote": "您的数据已加密且安全"
    },
    "voice": {
      "title": "语音控制",
      "description": "免提导航",
      "enabled": "语音命令",
      "enabledDesc": "用您的声音控制应用",
      "tts": "语音合成",
      "ttsDesc": "AI 回复朗读",
      "wakeWord": "唤醒词检测",
      "wakeWordDesc": "说 \"Bayit\" 激活",
      "operationMode": "操作模式",
      "operationModeDesc": "选择您与应用的互动方式",
      "voiceSearch": "语音搜索",
      "voiceSearchEnabled": "启用语音搜索",
      "voiceSearchEnabledDesc": "用您的声音搜索内容",
      "constantListening": "始终收听模式",
      "constantListeningDesc": "持续收听语音命令，无需按按钮",
      "constantListeningPrivacy": "音频仅在检测到语音时发送到服务器",
      "holdButtonMode": "按住按钮说话",
      "holdButtonModeDesc": "按住麦克风按钮而不是始终收听",
      "sensitivity": "语音检测灵敏度",
      "sensitivityDesc": "调整语音检测的响应程度",
      "sensitivityLow": "低（减少误触发）",
      "sensitivityMedium": "中（平衡）",
      "sensitivityHigh": "高（最敏感）",
      "silenceThreshold": "静音检测",
      "silenceThresholdDesc": "说话后等待多久开始处理",
      "language": "语音语言",
      "accessibility": "无障碍",
      "autoSubtitle": "自动启用字幕",
      "autoSubtitleDesc": "播放内容时自动显示字幕",
      "highContrast": "高对比度模式",
      "highContrastDesc": "增加对比度以提高可见性",
      "textSize": "文字大小",
      "textSizeSmall": "小",
      "textSizeMedium": "中",
      "textSizeLarge": "大",
      "voiceOnlyInfo": "仅语音模式",
      "voiceOnlyDetails": "说 \"Hi Bayit\" 激活。禁用遥控器。完全用语音命令导航。",
      "hybridInfo": "混合模式",
      "hybridDetails": "使用语音或遥控器。非语音操作时有语音反馈。",
      "classicInfo": "经典模式",
      "classicDetails": "禁用所有语音功能。仅遥控器。",
      "textToSpeech": "语音回复",
      "ttsEnabled": "启用语音回复",
      "ttsEnabledDesc": "应用会朗读语音命令的回复",
      "ttsVolume": "语音音量",
      "ttsSpeed": "语速",
      "hybridFeedback": "互动反馈",
      "voiceFeedback": "操作语音反馈",
      "voiceFeedbackDesc": "使用遥控器或点击按钮时获得语音确认",
      "feedbackExample": "示例：点击电影 → 应用说 \"正在播放 [电影名]\""
    },
    "dropdown": {
      "myProfile": "我的资料",
      "subscription": "订阅",
      "favorites": "收藏",
      "downloads": "下载",
      "signOut": "退出"
    },
    "guest": "访客",
    "morningRitual": "早间仪式",
    "watchlist": "观看列表",
    "favorites": "收藏",
    "downloads": "下载",
    "settings": "设置",
    "language": "语言",
    "admin": "管理",
    "watchTime": "观看时间",
    "minutes": "分钟",
    "hours": "小时",
    "logout": "退出登录",
    "premium": "高级版",
    "basic": "基础版",
    "upgrade": "升级到高级版",
    "memberSince": "注册于",
    "aiAssistant": "AI 助手",
    "voiceSettings": "语音",
    "subscriptionButton": "订阅",
    "recentActivity": "最近活动",
    "justNow": "刚刚",
    "hoursAgo": "{{hours}} 小时前",
    "yesterday": "昨天",
    "noRecentActivity": "无最近活动",
    "accountInfo": "账户信息",
    "role": "角色",
    "accountSecurity": "账户安全",
    "securityNote": "您的账户已通过加密认证保护",
    "lastLogin": "上次登录",
    "dangerZone": "危险区域",
    "invalidImageType": "请选择有效的图片文件（JPEG、PNG、WebP 或 GIF）",
    "imageTooLarge": "图片太大。最大大小为 5MB。",
    "uploadSuccess": "头像更新成功！",
    "uploadFailed": "头像上传失败。请重试。",
    "complimentaryPremium": "免费高级访问",
    "emailVerified": "邮箱已验证",
    "emailUnverified": "邮箱未验证",
    "phoneVerified": "手机已验证",
    "phoneUnverified": "手机未验证",
    "completeVerification": "完成验证以解锁所有功能",
    "unlockPremium": "解锁高级功能",
    "unlockPremiumDescription": "升级以享受独家内容和功能"
  },
  "voiceMode": {
    "voiceOnly": "仅语音",
    "voiceOnlyDesc": "无遥控器 - 完全语音导航",
    "hybrid": "混合",
    "hybridDesc": "语音 + 遥控器 - 操作时有语音反馈",
    "classic": "经典",
    "classicDesc": "无语音 - 仅遥控器"
  },
  "settings": {
    "title": "设置",
    "language": "语言",
    "appLanguage": "应用语言",
    "selectLanguage": "选择语言",
    "languages": {
      "en": "英语",
      "he": "希伯来语",
      "es": "西班牙语",
      "zh": "中文",
      "fr": "法语",
      "it": "意大利语",
      "hi": "印地语",
      "ta": "泰米尔语",
      "bn": "孟加拉语",
      "ja": "日本語"
    },
    "chatTranslation": "聊天翻译",
    "autoTranslate": "自动翻译消息",
    "autoTranslateDescription": "自动将聊天消息翻译成您的首选语言",
    "notifications": "通知",
    "pushNotifications": "推送通知",
    "playback": "播放",
    "quality": "画质",
    "subtitles": "字幕",
    "autoplay": "自动播放",
    "appearance": "外观",
    "darkMode": "深色模式",
    "privacy": "隐私",
    "privacyPolicy": "隐私政策",
    "termsOfService": "服务条款",
    "about": "关于",
    "display": "显示",
    "homePageSections": "首页版块",
    "configureSections": "配置首页显示的版块",
    "visibleSections": "可见版块",
    "hiddenSections": "隐藏版块",
    "dragToReorder": "拖动排序",
    "tapToHide": "点击隐藏",
    "tapToShow": "点击显示",
    "resetToDefault": "恢复默认",
    "resetConfirmMessage": "确定要将首页版块恢复为默认配置吗？",
    "sectionHidden": "版块已隐藏",
    "sectionShown": "版块已显示",
    "replayTour": "重播功能导览"
  },
  "help": {
    "subtitle": "我们能帮您什么？",
    "email": "邮件支持",
    "phone": "电话支持",
    "chat": "在线客服",
    "chatAvailable": "全天候可用",
    "openTooltip": "[zh] Open help tooltip",
    "openHelp": "[zh] Open help menu",
    "howTo": "[zh] How to use",
    "relatedArticles": "[zh] Related articles",
    "stillNeedHelp": "[zh] Still need help?",
    "contactSupport": "[zh] Contact Support",
    "previous": "[zh] Previous",
    "next": "[zh] Next",
    "getStarted": "[zh] Get Started",
    "skipTutorial": "[zh] Skip tutorial",
    "actions": {
      "search": "[zh] Search Help",
      "docs": "[zh] Documentation",
      "faq": "[zh] FAQ",
      "support": "[zh] Contact Support",
      "tutorial": "[zh] View Tutorial"
    },
    "search": {
      "placeholder": "[zh] Search help...",
      "noResults": "[zh] No results found for \"{{query}}\"",
      "noResultsHint": "[zh] Try different keywords or browse categories",
      "recent": "[zh] Recent",
      "popular": "[zh] Popular"
    },
    "categories": {
      "getting-started": "[zh] Getting Started",
      "features": "[zh] Features",
      "judaism": "[zh] Judaism",
      "platform-guides": "[zh] Platform Guides",
      "account": "[zh] Account",
      "troubleshooting": "[zh] Troubleshooting",
      "parents": "[zh] For Parents",
      "admin": "[zh] Admin Guide",
      "developer": "[zh] Developer API"
    },
    "faq": {
      "title": "常见问题",
      "q1": "如何更改我的订阅套餐？",
      "a1": "前往设置 > 订阅查看和更改您的当前套餐。您可以随时升级或降级。",
      "q2": "如何下载内容以供离线观看？",
      "a2": "点击任何内容上的下载图标将其保存以供离线观看。下载仅在移动设备上可用。",
      "q3": "为什么我的视频无法播放？",
      "a3": "请检查您的网络连接。如果问题仍然存在，请尝试清除应用缓存或重启应用。",
      "q4": "如何取消我的订阅？",
      "a4": "您可以随时通过设置 > 订阅 > 取消套餐取消订阅。您将在计费周期结束前继续拥有访问权限。"
    },
    "onboarding": {
      "welcome": {
        "title": "[zh] Welcome to Bayit+",
        "description": "[zh] Your home for Israeli entertainment, anywhere in the world"
      },
      "liveTv": {
        "title": "[zh] Live TV",
        "description": "[zh] Watch Israeli channels live, including news, sports, and entertainment"
      },
      "vod": {
        "title": "[zh] On-Demand Content",
        "description": "[zh] Browse movies, series, and documentaries anytime"
      },
      "voice": {
        "title": "[zh] Voice Control",
        "description": "[zh] Say 'Bayit' to control the app with your voice"
      },
      "profiles": {
        "title": "[zh] Family Profiles",
        "description": "[zh] Create profiles for each family member with personalized recommendations"
      }
    }
  },
  "voice": {
    "panelTitle": "语音助手",
    "typeCommand": "输入命令...",
    "controlExecuted": "已执行：{{action}}",
    "timerSet": "计时器已设置为 {{amount}} {{unit}}",
    "chatPending": "正在处理您的消息...",
    "suggestion": {
      "watchLive": "观看直播电视",
      "search": "搜索内容",
      "listenRadio": "收听广播"
    },
    "error": {
      "micDenied": "麦克风访问被拒绝",
      "notSupported": "此浏览器不支持语音命令",
      "recognitionFailed": "无法理解。请重试。"
    }
  },
  "errors": {
    "networkError": "网络错误",
    "loadingFailed": "加载失败",
    "tryAgain": "重试",
    "offline": {
      "title": "无网络连接",
      "message": "您当前处于离线状态。某些功能可能不可用。",
      "ttsMessage": "无网络连接。您现在处于离线模式。"
    },
    "online": {
      "title": "连接已恢复",
      "message": "您已重新上线。",
      "ttsMessage": "网络连接已恢复。"
    },
    "api": {
      "badRequest": "出现问题。请重试。",
      "unauthorized": "请登录以继续。",
      "forbidden": "您没有权限访问此内容。",
      "notFound": "您查找的内容不可用。",
      "rateLimit": "请求过于频繁。请稍候。",
      "serverError": "我们的服务器遇到问题。请稍后重试。",
      "unknown": "出现问题。请重试。",
      "networkTimeout": "无法连接到我们的服务器。请检查您的连接。",
      "offlineMessage": "您处于离线状态。请检查您的网络连接。",
      "requestFailed": "出现问题。请重试。"
    },
    "voice": {
      "permissionDenied": "语音命令需要麦克风权限。请在设置中启用。",
      "recognitionFailed": "我没有听懂。请重试。",
      "commandFailed": "语音命令失败。请重试。"
    },
    "widget": {
      "loadFailed": "无法加载小组件。请重试。"
    },
    "buttons": {
      "ok": "确定",
      "retry": "重试",
      "cancel": "取消"
    },
    "title": "错误",
    "networkUnavailable": "网络不可用",
    "no_audio_url": "无音频URL",
    "connection_failed": "连接失败",
    "quota_exceeded": "超出配额",
    "server_error": "服务器错误"
  },
  "player": {
    "loading": "加载中...",
    "retry": "重试",
    "error": "播放视频出错",
    "back": "← 返回",
    "liveBadge": "直播",
    "noStream": "流不可用",
    "loadError": "加载流失败",
    "settings": "设置",
    "subtitles": "[zh] Subtitles",
    "playbackSpeed": "播放速度",
    "quality": "画质",
    "auto": "自动",
    "previousChapter": "上一章",
    "nextChapter": "下一章",
    "skipBackward": "后退30秒",
    "skipForward": "前进30秒",
    "restart": "从头开始",
    "subtitlesOff": "关闭",
    "speed": "速度",
    "subscription": {
      "requiredTitle": "需要订阅",
      "requiredMessage": "需要付费订阅",
      "upgradeInfo": "升级您的订阅以访问高级内容",
      "upgrade": "立即升级"
    },
    "ai": {
      "dub": "Dub",
      "dubbing": "配音",
      "featuresTitle": "AI 功能",
      "languagePrimary": "主要",
      "languageSecondary": "次要（可选）",
      "languageTitle": "AI 语言",
      "liveTranslate": "实时翻译",
      "selectLanguage": "选择语言",
      "split": "分割",
      "togglePanel": "切换 AI 面板",
      "translate": "翻译",
      "trivia": "问答",
      "triviaToggle": "[zh] Trivia"
    },
    "catchup": {
      "description": "错过了开头？获取 AI 生成的剧情摘要。",
      "generateSummary": "生成摘要",
      "summaryTitle": "摘要",
      "title": "回看",
      "keyPoints": "[zh] Key Points",
      "transcript": "[zh] Transcript"
    },
    "chat": {
      "title": "实时聊天",
      "messagePlaceholder": "输入消息..."
    },
    "companion": {
      "noContext": "此内容暂无文化背景信息。",
      "quizComplete": "测验完成",
      "quizRetry": "重试",
      "quizStart": "开始测验",
      "quizTitle": "准备好测试您的知识了吗？",
      "quizTryAgain": "重试",
      "tabContext": "上下文",
      "tabQuiz": "测验",
      "tabVocabulary": "词汇",
      "tapWords": "点击字幕中的单词添加到此处",
      "title": "AI 伴侣",
      "loadError": "加载学习数据失败"
    },
    "controls": {
      "audioTrack": "音轨",
      "continueWatching": "继续观看",
      "dismiss": "关闭",
      "goBack": "返回",
      "navigateBack": "返回导航",
      "on": "ON",
      "pause": "暂停",
      "play": "播放",
      "preview": "预览",
      "selected": "已选择",
      "send": "发送",
      "skip": "跳过",
      "close": "[zh] Close",
      "exitFullscreen": "[zh] Exit Fullscreen",
      "fullscreen": "[zh] Fullscreen",
      "restart": "[zh] Restart",
      "skipBackward": "[zh] Skip Backward",
      "skipForward": "[zh] Skip Forward",
      "volume": "[zh] Volume"
    },
    "dubbing": {
      "notNow": "暂时不要",
      "premiumMessage": "实时配音需要 Premium 或 Beta 500 订阅",
      "premiumTitle": "高级功能",
      "upgrade": "升级",
      "voiceTitle": "配音声音",
      "settings_title": "实时配音设置",
      "target_language": "目标语言"
    },
    "errors": {
      "streamLimitMessage": "您已达到 {{maxStreams}} 个并发串流的上限。请停止其他串流或升级您的方案。",
      "streamLimitTitle": "已达串流上限",
      "upgradePlan": "升级方案"
    },
    "audio_description": "音频描述",
    "dismiss": "关闭",
    "scene_search": "场景搜索",
    "search_placeholder": "搜索场景...",
    "language_ratio": "语言学习比例",
    "go_back": "返回",
    "sleepTimer": {
      "title": "睡眠定时器",
      "subtitle": "在设定时间后自动暂停播放",
      "minutes": "{{count}} 分钟",
      "customPlaceholder": "自定义分钟数",
      "set": "设置定时器",
      "remaining": "{{time}}后暂停",
      "extend": "+15 分钟",
      "cancel": "取消定时器",
      "off": "[zh] Off",
      "setTimer": "[zh] Set Sleep Timer"
    },
    "openSubs": {
      "title": "搜索字幕",
      "searchPlaceholder": "按标题搜索...",
      "search": "搜索",
      "searchFailed": "搜索失败，请重试。",
      "downloads": "{{count}} 次下载",
      "noResults": "未找到字幕"
    },
    "dialogue": {
      "cancel": "[zh] Cancel",
      "close": "[zh] Close",
      "placeholder": "[zh] Type your message...",
      "selectCharacter": "[zh] Select Character",
      "send": "[zh] Send",
      "sharedSession": "[zh] Shared Session",
      "waitingForTurn": "[zh] Waiting for your turn...",
      "yourAvatar": "[zh] Your Avatar"
    },
    "interaction": {
      "next": "[zh] Next",
      "previous": "[zh] Previous",
      "skip": "跳过",
      "start": "开始互动",
      "window": "互动窗口：{{duration}} 秒"
    },
    "pauseAsk": {
      "askAgain": "[zh] Ask Again",
      "placeholder": "[zh] Ask about this scene...",
      "resume": "[zh] Resume",
      "resumeMovie": "[zh] Resume Movie",
      "selectCharacter": "[zh] Select Character",
      "title": "[zh] Pause & Ask"
    },
    "phraseBreakdown": {
      "literal": "字面意思",
      "meaning": "含义",
      "origin": "来源",
      "funFact": "趣味知识",
      "usage": "用法：{{level}}"
    },
    "translation": {
      "example": "例句：",
      "arrow": "→"
    },
    "subtitleMode": {
      "title": "字幕模式",
      "modes": {
        "regular": {
          "name": "普通",
          "description": "标准希伯来语字幕，无元音标记"
        },
        "nikud": {
          "name": "尼库德",
          "description": "带元音标记的希伯来语，便于阅读"
        },
        "shoresh": {
          "name": "词根",
          "description": "基于词根的学习，突出显示词源"
        },
        "engrew": {
          "name": "英希混合",
          "description": "带希伯来语语境的英语音译"
        },
        "heblish": {
          "name": "希英混合",
          "description": "含有希伯来语词汇和文化背景的英语"
        },
        "grammarFlip": {
          "name": "语法翻转",
          "description": "使用英语词汇的希伯来语句子结构"
        },
        "slangSynthesis": {
          "name": "俚语综合",
          "description": "文化俚语和习语讲解"
        }
      }
    }
  },
  "empty": {
    "noContent": "无可用内容",
    "tryAnotherCategory": "尝试选择其他分类",
    "noPodcasts": "无可用播客",
    "tryLater": "请稍后重试",
    "noResults": "未找到结果"
  },
  "content": {
    "play": "播放",
    "addToList": "添加到列表",
    "inList": "在列表中",
    "details": "详情",
    "synopsis": "简介",
    "genre": "类型",
    "genres": "类型",
    "runtime": "时长",
    "released": "上映",
    "director": "导演",
    "starring": "主演",
    "cast": "演员",
    "season": "季",
    "seasons": "季",
    "episode": "集",
    "episodes": "集",
    "ep": "第",
    "selectSeason": "选择季",
    "noEpisodes": "无可用剧集",
    "noEpisodesAvailable": "无可播放的剧集",
    "loadingSeries": "加载剧集信息...",
    "votes": "票",
    "rating": "评分",
    "imdbRating": "IMDB 评分",
    "preview": "预览",
    "previewPlaying": "正在播放预览",
    "trailerPlaying": "正在播放预告片",
    "watchTrailer": "观看预告片",
    "youMayAlsoLike": "您可能还喜欢",
    "relatedContent": "相关内容",
    "notFound": "未找到内容",
    "availableSubtitles": "可用字幕",
    "subtitleSelected": "已选择：{{language}}"
  },
  "breadcrumbs": {
    "series": "剧集",
    "movie": "电影",
    "watching": "正在观看",
    "channel": "频道",
    "station": "电台",
    "podcast": "播客",
    "watchlist": "观看列表",
    "downloads": "下载"
  },
  "favorites": {
    "title": "收藏",
    "items": "项目",
    "empty": "暂无收藏",
    "emptyHint": "将项目添加到您的收藏"
  },
  "downloads": {
    "title": "下载",
    "items": "项目",
    "storage": "存储",
    "empty": "无下载",
    "emptyHint": "下载内容以供离线观看",
    "paused": "已暂停"
  },
  "watchlist": {
    "filters": {
      "all": "全部",
      "continue": "继续观看",
      "movies": "电影",
      "series": "剧集",
      "kids": "儿童",
      "judaism": "犹太教",
      "podcasts": "播客",
      "radio": "广播"
    },
    "title": "观看列表",
    "items": "项目",
    "watched": "[zh] watched",
    "empty": "您的观看列表为空",
    "emptyHint": "开始观看，项目将显示在此处"
  },
  "widgets": {
    "empty": "暂无小组件",
    "emptyHint": "您的小组件将显示在此处",
    "emptyPersonal": "暂无个人小组件",
    "emptyPersonalHint": "创建您的第一个个人小组件或添加上方的系统小组件",
    "itemsTotal": "总小组件",
    "systemWidgets": "系统小组件",
    "systemWidgetsHint": "浏览并添加小组件到您的收藏",
    "myWidgets": "我的个人小组件",
    "myWidgetsHint": "您创建的小组件",
    "personalWidgets": "我的小组件",
    "noSystemWidgets": "无可用系统小组件",
    "added": "已添加",
    "add": "添加",
    "remove": "移除",
    "show": "显示",
    "hidden": "隐藏",
    "addToCollection": "添加到我的小组件",
    "removeFromCollection": "从我的小组件移除",
    "contentTypes": {
      "liveChannel": "直播频道",
      "iframe": "网页内容",
      "podcast": "播客",
      "radio": "广播",
      "vod": "视频",
      "custom": "自定义",
      "widget": "小组件"
    },
    "form": {
      "title": "创建小组件",
      "basicInfo": "基本信息",
      "titlePlaceholder": "小组件标题",
      "titleRequired": "小组件标题为必填项",
      "descriptionPlaceholder": "描述（可选）",
      "iconPlaceholder": "图标表情（如📺）",
      "content": "内容",
      "fromLibrary": "从资料库",
      "iframe": "iFrame",
      "selectContent": "选择内容（频道、播客、节目等）",
      "iframeUrl": "iFrame 网址",
      "iframeUrlRequired": "iFrame URL 为必填项",
      "iframeTitle": "iFrame 标题",
      "positionSize": "位置与大小",
      "behavior": "行为",
      "mutedByDefault": "默认静音",
      "closable": "可关闭",
      "draggable": "可拖动",
      "widgetOrder": "小组件顺序",
      "orderPlaceholder": "顺序（0 = 第一个）",
      "saveWidget": "保存小组件",
      "saving": "保存中...",
      "cancel": "取消",
      "change": "更改"
    }
  },
  "trending": {
    "title": "以色列热门话题",
    "noTopics": "无可用热门话题",
    "topStory": "头条新闻",
    "sources": "来源",
    "categories": {
      "security": "安全",
      "politics": "政治",
      "tech": "科技",
      "culture": "文化",
      "sports": "体育",
      "economy": "经济",
      "entertainment": "娱乐",
      "weather": "天气",
      "health": "健康",
      "general": "综合"
    }
  },
  "cultures": {
    "title": "文化",
    "select": "选择文化",
    "selectCulture": "选择您的文化",
    "selectCultureDescription": "选择一种文化来个性化您的内容",
    "changeCulture": "更改文化",
    "israeli": {
      "name": "以色列",
      "description": "以色列社区内容"
    },
    "chinese": {
      "name": "中国",
      "description": "中国社区内容"
    },
    "japanese": {
      "name": "日本",
      "description": "日本社区内容"
    },
    "korean": {
      "name": "韩国",
      "description": "韩国社区内容"
    },
    "indian": {
      "name": "印度",
      "description": "印度社区内容"
    }
  },
  "cultureTrending": {
    "whatsHotIn": "{{location}}热门",
    "noTopics": "暂无热门话题",
    "sources": "来源",
    "categories": {
      "security": "[zh] Security",
      "politics": "[zh] Politics",
      "tech": "[zh] Tech",
      "technology": "[zh] Technology",
      "culture": "[zh] Culture",
      "sports": "[zh] Sports",
      "economy": "[zh] Economy",
      "finance": "[zh] Finance",
      "entertainment": "[zh] Entertainment",
      "weather": "[zh] Weather",
      "health": "[zh] Health",
      "food": "[zh] Food",
      "fashion": "[zh] Fashion",
      "travel": "[zh] Travel",
      "history": "[zh] History",
      "expat": "[zh] Expat Life",
      "general": "[zh] General"
    }
  },
  "cultureClock": {
    "timeIn": "{{location}}时间",
    "shabbat": "安息日",
    "weekend": "周末"
  },
  "cultureCities": {
    "connectionTo": "{{city}}连接",
    "explore": "[zh] Explore {{city}}",
    "noContent": "暂无内容",
    "categories": {
      "all": "全部",
      "history": "[zh] History",
      "culture": "文化",
      "finance": "[zh] Finance",
      "tech": "科技",
      "food": "美食",
      "expat": "[zh] Expat Life",
      "news": "新闻",
      "entertainment": "娱乐"
    }
  },
  "clock": {
    "israel": "以色列",
    "local": "本地",
    "shabbatShalom": "安息日平安！",
    "erevShabbat": "安息日前夜",
    "candleLighting": "点蜡烛",
    "parasha": "每周圣经"
  },
  "ritual": {
    "title": "早间仪式",
    "greeting": "早上好！",
    "israelUpdate": "以色列现在是下午，新闻正在报道最新动态",
    "recommendation": "我们建议先看早间新闻，然后收听广播",
    "preparingRitual": "正在准备您的早间仪式...",
    "israelTime": "以色列时间",
    "day": "日",
    "letsStart": "开始",
    "skipToday": "今天跳过",
    "finish": "完成",
    "noContentNow": "当前无可用内容",
    "typeLive": "直播",
    "typeRadio": "广播",
    "typeVideo": "视频"
  },
  "watchParty": {
    "title": "观影派对",
    "create": "创建派对",
    "join": "加入派对",
    "active": "派对进行中",
    "createTitle": "创建观影派对",
    "joinTitle": "加入派对",
    "enterCode": "输入房间代码",
    "roomCode": "房间代码",
    "copyCode": "复制代码",
    "codeCopied": "代码已复制！",
    "participants": "参与者",
    "host": "主持人",
    "you": "您",
    "leave": "离开派对",
    "end": "结束派对",
    "chat": "聊天",
    "sendMessage": "发送消息",
    "typeMessage": "输入消息...",
    "synced": "已同步",
    "syncing": "同步中...",
    "hostPaused": "主持人已暂停",
    "userJoined": "{{name}} 加入了",
    "userLeft": "{{name}} 离开了",
    "partyEnded": "派对已结束",
    "connecting": "连接中...",
    "options": {
      "chatEnabled": "启用聊天",
      "syncPlayback": "同步播放"
    },
    "errors": {
      "invalidCode": "无效代码",
      "partyFull": "派对已满",
      "partyEnded": "派对已结束",
      "connectionError": "连接错误",
      "createFailed": "创建派对失败",
      "joinFailed": "加入派对失败"
    },
    "audio": {
      "mute": "静音",
      "unmute": "取消静音",
      "speaking": "正在说话",
      "connecting": "正在连接音频...",
      "noAudio": "音频不可用"
    },
    "textOnlyMode": "仅文字聊天",
    "endParty": "结束派对"
  },
  "footer": {
    "brandDescription": "美国的您的家。希伯来语的电视广播、点播、广播和播客。",
    "browse": "浏览",
    "account": "账户",
    "support": "支持",
    "legal": "法律",
    "location": "纽约，美国",
    "links": {
      "home": "首页",
      "liveTV": "直播电视",
      "vod": "电影与剧集",
      "radio": "广播",
      "podcasts": "播客",
      "judaism": "犹太教",
      "profile": "我的资料",
      "favorites": "收藏",
      "watchlist": "观看列表",
      "subscribe": "订阅",
      "downloads": "下载",
      "help": "帮助中心",
      "faq": "常见问题",
      "contact": "联系我们",
      "feedback": "反馈",
      "terms": "服务条款",
      "privacy": "隐私政策",
      "cookies": "Cookie 政策",
      "licenses": "许可证"
    },
    "newsletter": {
      "title": "保持更新",
      "description": "订阅我们的通讯以获取最新更新和独家内容。",
      "placeholder": "输入您的电子邮件",
      "success": "感谢订阅！"
    },
    "apps": {
      "title": "获取应用",
      "downloadOn": "下载于",
      "getItOn": "获取于",
      "appStore": "App Store",
      "googlePlay": "Google Play"
    },
    "social": {
      "facebook": "Facebook",
      "twitter": "Twitter",
      "instagram": "Instagram",
      "youtube": "YouTube"
    },
    "copyright": "© {{year}} Bayit+。保留所有权利。",
    "poweredBy": "技术支持",
    "sitemap": "网站地图",
    "accessibility": "无障碍",
    "navigation": "导航",
    "liveTV": "直播电视",
    "moviesAndSeries": "电影与剧集",
    "radioStations": "电台",
    "myProfile": "我的资料",
    "subscriptions": "订阅",
    "helpAndSupport": "帮助与支持",
    "termsOfUse": "使用条款",
    "privacyPolicy": "隐私政策",
    "contactUs": "联系我们"
  },
  "chapters": {
    "title": "章节",
    "noChapters": "无可用章节",
    "generating": "正在生成章节...",
    "jumpTo": "跳转到",
    "current": "现在",
    "categories": {
      "intro": "介绍",
      "news": "新闻",
      "security": "安全",
      "politics": "政治",
      "economy": "经济",
      "sports": "体育",
      "weather": "天气",
      "culture": "文化",
      "conclusion": "结论"
    },
    "chapterLabel": "第 {{number}} 章",
    "chapter_number": "第{{number}}章"
  },
  "admin": {
    "brand": {
      "title": "Bayit+ 管理",
      "subtitle": "系统管理"
    },
    "backToApp": "返回应用",
    "refunds": {
      "subtitle": "管理退款请求",
      "approveModal": {
        "title": "确认批准",
        "message": "批准退款 {{amount}}？"
      },
      "confirmApprove": "批准退款 {{amount}}？",
      "confirmDelete": "删除退款请求？",
      "rejectModal": {
        "title": "拒绝退款请求",
        "message": "拒绝退款 {{amount}}",
        "reasonLabel": "拒绝原因",
        "reasonPlaceholder": "请输入拒绝原因...",
        "submitButton": "拒绝请求"
      },
      "status": {
        "pending": "待处理",
        "approved": "已批准",
        "rejected": "已拒绝"
      },
      "columns": {
        "id": "ID",
        "user": "用户",
        "amount": "金额",
        "reason": "原因",
        "status": "状态",
        "requestDate": "请求日期"
      },
      "stats": {
        "pendingTitle": "待批准",
        "approvedTitle": "已批准",
        "rejectedTitle": "已拒绝",
        "totalRefunded": "总退款金额"
      },
      "emptyMessage": "未找到退款请求",
      "errors": {
        "rejectReasonRequired": "请输入拒绝原因"
      },
      "title": "退款"
    },
    "plans": {
      "title": "套餐管理",
      "subtitle": "配置和管理订阅套餐",
      "createButton": "新建套餐",
      "inactive": "未激活",
      "subscribersLabel": "订阅者：",
      "intervals": {
        "monthly": "月",
        "yearly": "年"
      },
      "trialDays": "{{days}} 天试用",
      "modal": {
        "editTitle": "编辑套餐",
        "createTitle": "新建套餐"
      },
      "form": {
        "nameEn": "名称（英文）",
        "nameHe": "名称（希伯来文）",
        "price": "价格（$）",
        "interval": "计费周期",
        "trialDays": "试用天数",
        "features": "功能（每行一个）",
        "active": "激活套餐"
      },
      "errors": {
        "requiredFields": "名称和价格为必填项"
      },
      "confirmDelete": "删除套餐 \"{{name}}\"？"
    },
    "emailCampaigns": {
      "subtitle": "创建和管理邮件活动",
      "createButton": "新建活动",
      "searchPlaceholder": "搜索活动...",
      "emptyMessage": "未找到活动",
      "status": {
        "draft": "草稿",
        "active": "活跃",
        "scheduled": "已计划",
        "completed": "已完成"
      },
      "columns": {
        "name": "活动名称",
        "status": "状态",
        "sent": "已发送",
        "opened": "已打开",
        "clicked": "已点击",
        "created": "创建日期",
        "actions": "操作"
      },
      "editModal": {
        "title": "编辑活动"
      },
      "sendTestEmail": "发送测试",
      "confirmSend": "发送活动 \"{{name}}\"？",
      "confirmDelete": "删除活动 \"{{name}}\"？",
      "testEmailSent": "测试邮件已发送！",
      "createModal": {
        "title": "新建邮件活动"
      },
      "form": {
        "name": "活动名称",
        "namePlaceholder": "例如：年终促销",
        "subject": "邮件主题",
        "subjectPlaceholder": "显示给收件人的主题",
        "body": "内容",
        "bodyPlaceholder": "邮件内容...",
        "submitButton": "创建活动",
        "requiredFields": "名称和主题为必填项"
      },
      "testModal": {
        "title": "发送测试邮件",
        "emailLabel": "邮箱地址",
        "emailPlaceholder": "test@example.com",
        "submitButton": "发送测试"
      },
      "errors": {
        "requiredFields": "名称和主题为必填项"
      }
    },
    "dashboard": {
      "subtitle": "系统概览",
      "refresh": "刷新",
      "timeAgo": {
        "minutes": "{{count}} 分钟前",
        "hours": "{{count}} 小时前"
      },
      "title": "仪表板",
      "users": "用户",
      "revenue": "收入",
      "subscriptions": "订阅",
      "recentActivity": "最近活动",
      "quickActions": "快捷操作"
    },
    "common": {
      "all": "全部",
      "cancel": "取消",
      "save": "保存",
      "active": "活跃",
      "back": "返回",
      "filterAction": "操作",
      "filterResource": "资源",
      "filterUser": "用户",
      "filterDateRange": "日期范围"
    },
    "stats": {
      "totalUsers": "总用户",
      "activeUsers": "活跃用户",
      "newToday": "今日新增",
      "newThisWeek": "本周新增",
      "totalRevenue": "总收入",
      "revenueToday": "今日收入",
      "revenueMonth": "本月收入",
      "arpu": "每用户平均收入",
      "activeSubscriptions": "活跃订阅",
      "churnRate": "流失率"
    },
    "actions": {
      "new": "新建",
      "addUser": "添加用户",
      "newCampaign": "新建活动",
      "sendEmail": "发送邮件",
      "viewReports": "查看报告"
    },
    "auditActions": {
      "user_created": "用户已创建",
      "user_updated": "用户已更新",
      "user_deleted": "用户已删除",
      "user_role_changed": "用户角色已更改",
      "campaign_created": "活动已创建",
      "campaign_updated": "活动已更新",
      "campaign_deleted": "活动已删除",
      "campaign_activated": "活动已激活",
      "subscription_created": "订阅已创建",
      "subscription_updated": "订阅已更新",
      "subscription_canceled": "订阅已取消",
      "subscription_deleted": "订阅已删除",
      "refund_processed": "退款已处理",
      "payment_received": "收到付款",
      "settings_updated": "设置已更新",
      "login": "登录",
      "logout": "登出",
      "content_created": "内容已创建",
      "content_updated": "内容已更新",
      "content_deleted": "内容已删除",
      "content_published": "内容已发布",
      "content_unpublished": "内容已下架",
      "category_created": "分类已创建",
      "category_updated": "分类已更新",
      "category_deleted": "分类已删除",
      "live_channel_created": "直播频道已创建",
      "live_channel_updated": "直播频道已更新",
      "live_channel_deleted": "直播频道已删除",
      "radio_station_created": "电台已创建",
      "radio_station_updated": "电台已更新",
      "radio_station_deleted": "电台已删除",
      "podcast_created": "播客已创建",
      "podcast_updated": "播客已更新",
      "podcast_deleted": "播客已删除",
      "podcast_episode_created": "播客剧集已创建",
      "podcast_episode_updated": "播客剧集已更新",
      "podcast_episode_deleted": "播客剧集已删除",
      "content_imported": "内容已导入",
      "widget_created": "小组件已创建",
      "widget_updated": "小组件已更新",
      "widget_deleted": "小组件已删除",
      "widget_published": "小组件已发布",
      "widget_unpublished": "小组件已下架"
    },
    "placeholder": {
      "userId": "输入用户 ID",
      "discount": "0"
    },
    "titles": {
      "users": "用户",
      "transactions": "交易",
      "subscriptions": "订阅",
      "refunds": "退款",
      "plans": "套餐",
      "campaigns": "活动",
      "auditLogs": "审计日志",
      "pushNotifications": "推送通知",
      "billing": "账单",
      "marketing": "营销",
      "content": "内容库",
      "categories": "分类",
      "liveChannels": "直播频道",
      "radioStations": "电台",
      "podcasts": "播客",
      "settings": "设置"
    },
    "nav": {
      "dashboard": "仪表板",
      "users": "用户",
      "campaigns": "活动",
      "billing": "账单",
      "billingOverview": "概览",
      "transactions": "交易",
      "refunds": "退款",
      "subscriptions": "订阅",
      "subscriptionsList": "订阅者",
      "plans": "套餐",
      "marketing": "营销",
      "marketingDashboard": "概览",
      "emailCampaigns": "邮件活动",
      "pushNotifications": "推送通知",
      "content": "内容",
      "contentLibrary": "内容库",
      "categories": "分类",
      "liveChannels": "直播频道",
      "radioStations": "电台",
      "podcasts": "播客",
      "widgets": "小组件",
      "recordings": "录制",
      "uploads": "上传",
      "settings": "设置",
      "auditLogs": "审计日志",
      "librarian": "管理员代理",
      "featured": "精选"
    },
    "featured": {
      "title": "精选内容",
      "subtitle": "管理首页轮播的精选内容",
      "empty": "无精选内容",
      "emptyHint": "精选项目将显示在首页对应的轮播中",
      "count": "{{count}} 个项目",
      "confirmUnfeature": "从精选中移除？",
      "remove": "移除",
      "unsavedChanges": "有未保存的更改",
      "section": {
        "title": "{{name}}",
        "itemCount": "{{count}} 个项目",
        "itemCount_plural": "{{count}} 个项目",
        "empty": "无精选项目",
        "emptyHint": "精选项目将显示在首页的 {{name}} 轮播中"
      },
      "saveButton": "保存 {{count}} 个版块",
      "saveButton_plural": "保存 {{count}} 个版块",
      "saving": "保存中...",
      "saveSuccess": "精选内容更新成功",
      "saveFailed": "保存精选内容失败",
      "removeConfirm": "从 {{section}} 中移除？",
      "removeSuccess": "已从 {{section}} 中移除"
    },
    "recordings": {
      "title": "录制管理",
      "subtitle": "管理平台上的用户录制",
      "totalRecordings": "总录制数",
      "totalStorage": "总存储",
      "totalUsers": "有录制的用户",
      "activeSessions": "活跃会话",
      "searchPlaceholder": "按标题、用户或频道搜索...",
      "user": "用户",
      "confirmDelete": "删除录制 '{{title}}'？此操作无法撤销。",
      "deleteRecording": "删除录制",
      "deleteSuccess": "录制删除成功",
      "deleteFailed": "删除录制失败",
      "loadFailed": "加载录制失败",
      "noRecordings": "未找到录制",
      "noRecordingsHint": "系统中暂无用户录制。"
    },
    "uploads": {
      "title": "上传管理",
      "subtitle": "管理内容上传和自动文件夹监控",
      "activeUploads": "活跃上传",
      "noActiveUploads": "无活跃上传",
      "queuedUploads": "排队上传",
      "queued": "已排队",
      "andMore": "还有 {{count}} 个",
      "monitoredFolders": "监控文件夹",
      "noMonitoredFolders": "未配置监控文件夹",
      "configureFoldersHelp": "点击「添加文件夹」配置用于自动上传的监控文件夹",
      "addFolder": "添加文件夹",
      "editFolder": "编辑文件夹",
      "deleteFolder": "删除文件夹",
      "confirmDelete": "删除此文件夹？",
      "triggerUpload": "触发上传",
      "triggerUploadSuccess": "找到 {{files_found}} 个新文件待上传",
      "triggerUploadFailed": "触发上传扫描失败",
      "noFilesFound": "在监控文件夹中未找到新文件",
      "sessionIssue": "会话问题",
      "sessionIssueHelp": "您的会话可能已过期。请刷新页面以恢复连接。",
      "sessionExpired": "会话已过期。请刷新页面或重新登录。",
      "unauthorized": "会话无效。请刷新页面。",
      "endpointNotFound": "上传服务不可用。请检查服务器配置。",
      "timeout": "上传扫描超时。请重试或检查监控文件夹。",
      "wsDisconnected": "实时更新已禁用",
      "wsDisconnectedHelp": "WebSocket 连接失败。队列状态可能已过时。页面将自动重试。",
      "wsReconnecting": "正在重新连接实时更新...",
      "uploadAlreadyRunning": "上传扫描正在进行中。请等待当前上传完成。",
      "uploadsActiveNotice": "上传进行中（{{processing}} 个活跃，{{queued}} 个排队）。当前批次完成前禁用新扫描。",
      "clearQueue": "清除队列",
      "clearQueueConfirmTitle": "清除上传队列？",
      "clearQueueConfirmMessage": "这将取消 {{count}} 个活跃任务。此操作无法撤销。",
      "clearQueueSuccess": "队列清除成功",
      "clearQueueFailed": "清除队列失败",
      "cancelUpload": "取消",
      "cancelUploadConfirm": "取消此上传？",
      "cancelUploadSuccess": "上传已取消",
      "cancelUploadFailed": "取消上传失败",
      "resetCache": "重置缓存",
      "cacheResetSuccess": "缓存已清除：{{count}} 个文件将在下次扫描时重新扫描",
      "cacheResetFailed": "重置缓存失败",
      "contentTypeFilters": "内容类型筛选",
      "contentTypeFiltersHelp": "可选 - 留空处理所有内容类型",
      "moviesOnly": "仅电影",
      "seriesOnly": "仅剧集",
      "audiobooksOnly": "仅有声书",
      "type": "类型",
      "lastScan": "上次扫描",
      "systemInfo": "上传系统信息",
      "systemInfoText": "上传期间自动从本地视频文件中提取字幕以加快处理速度",
      "languagesInfo": "支持的字幕语言：英语 (en)、希伯来语 (he)、西班牙语 (es)",
      "queueStatus": "上传队列",
      "totalJobs": "总计",
      "processing": "活跃",
      "completed": "已完成",
      "skipped": "已跳过",
      "failed": "失败",
      "queuePaused": "队列已暂停",
      "resumeQueue": "恢复",
      "activeUpload": "活跃上传",
      "queuedItems": "已排队",
      "noQueuedItems": "队列中无项目",
      "addedAt": "添加时间",
      "recentCompleted": "最近完成",
      "stages": {
        "browserUpload": "上传到服务器",
        "hashCalculation": "计算哈希",
        "duplicateCheck": "检查重复",
        "metadataExtraction": "提取元数据",
        "gcsUpload": "上传到云端",
        "databaseInsert": "保存到数据库",
        "imdbLookup": "获取 IMDB 信息",
        "subtitleExtraction": "提取字幕",
        "completed": "已完成",
        "failed": "失败",
        "skipped": "已跳过"
      },
      "form": {
        "name": "文件夹名称",
        "namePlaceholder": "我的电影文件夹",
        "path": "文件夹路径",
        "pathHelp": "输入服务器文件夹路径（例如 /Volumes/USB Drive/Movies）",
        "contentType": "内容类型",
        "enabled": "已启用",
        "autoUpload": "自动上传"
      },
      "contentTypes": {
        "movie": "电影",
        "series": "剧集",
        "audiobook": "有声书"
      },
      "errors": {
        "pathRequired": "文件夹路径为必填项"
      },
      "manualUpload": {
        "title": "手动上传",
        "subtitle": "拖放文件或选择文件夹",
        "dropHere": "拖放文件到此处或点击浏览",
        "dropHereActive": "放下文件以添加",
        "selectFolder": "选择文件夹",
        "supportedFormats": "支持视频文件（mp4、mkv、avi、mov、webm）",
        "selectedFiles": "已选文件",
        "noFilesSelected": "未选择文件",
        "clearAll": "清除全部",
        "uploadSelected": "上传所选",
        "selectContentType": "选择上传的内容类型",
        "uploadingFiles": "正在添加 {{count}} 个文件到队列...",
        "uploadSuccess": "成功添加 {{count}} 个文件到队列",
        "uploadFailed": "添加文件到队列失败",
        "fileSize": "大小",
        "removeFile": "移除",
        "invalidFileType": "无效的文件类型。仅支持视频文件。",
        "filesCount": "已选择 {{count}} 个文件",
        "pendingRestore": "{{count}} 个文件来自上次会话",
        "pendingRestoreHint": "拖放或选择相同的文件以恢复您的上传队列"
      }
    },
    "librarian": {
      "title": "管理员代理",
      "subtitle": "自主 AI 驱动的内容库管理",
      "loading": "加载管理员代理中...",
      "loadingConfig": "加载配置中...",
      "refresh": "刷新",
      "errors": {
        "configError": "配置错误",
        "configNotLoaded": "配置未加载",
        "failedToLoad": "加载管理员数据失败",
        "failedToLoadConfig": "加载管理员配置失败",
        "failedToTrigger": "触发审计失败。请重试。",
        "failedToLoadDetails": "加载报告详情失败。",
        "failedToRollback": "回滚操作失败。",
        "failedToClearReports": "清除审计报告失败。请重试。",
        "failedToPause": "暂停审计失败",
        "failedToResume": "恢复审计失败",
        "failedToCancel": "取消审计失败",
        "failedToInterject": "向 AI 代理发送消息失败",
        "auditAlreadyRunning": "审计正在运行中。请等待完成或取消后再开始新的审计。",
        "budgetExceeded": "已超出月度预算限制。无法运行审计。",
        "contactAdmin": "没有正确配置，管理员页面无法加载。\n请联系您的管理员。"
      },
      "stats": {
        "systemHealth": "系统健康",
        "totalAudits": "总审计数（30天）",
        "last30Days": "最近30天",
        "issuesFixed": "已修复问题",
        "lastAudit": "上次审计",
        "never": "从未",
        "unknown": "未知"
      },
      "health": {
        "excellent": "优秀",
        "good": "良好",
        "fair": "一般",
        "poor": "较差",
        "unknown": "未知"
      },
      "quickActions": {
        "title": "运行配置",
        "subtitle": "配置和触发审计",
        "auditMode": "审计模式",
        "auditModeHelp": "选择要检查的内容",
        "dryRun": "预览模式",
        "dryRunHelp": "显示将要更改的内容而不实际更改",
        "scopeFilters": "审计功能",
        "scopeFiltersHelp": "选择要启用的功能（可多选组合）",
        "last24Hours": "仅最近内容",
        "last24HoursHelp": "将审计限制在最近24小时添加的内容",
        "cybTitlesOnly": "清理脏标题",
        "cybTitlesOnlyHelp": "从标题中删除文件扩展名、质量标记和发布标签",
        "tmdbPostersOnly": "TMDB 海报和元数据",
        "tmdbPostersOnlyHelp": "从 TMDB 获取缺失的海报、描述和元数据",
        "openSubtitlesEnabled": "获取字幕",
        "openSubtitlesEnabledHelp": "从 OpenSubtitles 下载缺失的字幕（HE/EN/ES）",
        "classifyOnly": "验证分类",
        "classifyOnlyHelp": "检查并修复电影与剧集的分类错误",
        "purgeDuplicates": "删除重复",
        "purgeDuplicatesHelp": "查找并删除重复的内容项",
        "auditType": "审计类型",
        "auditTypeHelp": "选择基于规则或 AI 驱动的审计",
        "dailyAudit": "每日审计",
        "dailyBadge": "基于规则 • 快速 • 免费",
        "dailyDescription": "对最近7天修改的内容运行预定义检查。快速可预测，无 AI 成本。",
        "aiAgentAudit": "AI 代理审计",
        "aiAgentBadge": "AI 驱动 • 智能 • 使用预算",
        "aiAgentDescription": "自主 AI 代理（Claude）智能决定检查和修复什么。更全面但使用 API 预算。",
        "triggerDaily": "运行每日审计",
        "triggerAI": "运行 AI 代理审计",
        "auditRunningNotice": "审计正在运行。完成后按钮将启用。",
        "budgetLabel": "AI 代理预算限制：${{budget}}",
        "budgetPerAudit": "每次审计预算",
        "monthlyBudgetUsed": "已用预算（30天）",
        "monthlyBudgetLimit": "/ ${{limit}} 月度",
        "budgetWarning": "运行此审计将超出月度预算限制",
        "aiAuditSuccess": "AI 代理审计触发成功。{{dryRun}}",
        "dailyAuditSuccess": "每日审计触发成功。{{dryRun}}",
        "dryRunMode": "（预览模式）",
        "rollbackSuccess": "操作回滚成功。"
      },
      "voice": {
        "title": "语音控制",
        "description": "使用语音向管理员发出命令。只需按下按钮并自然说话。",
        "pressToSpeak": "按下说话",
        "listening": "正在听...",
        "transcript": "转录",
        "processing": "正在处理您的命令...",
        "speaking": "管理员正在回复...",
        "examples": "示例命令",
        "example1": "检查最近24小时缺失的海报",
        "example2": "修复 CYB 标题的元数据",
        "example3": "扫描损坏的流媒体 URL",
        "example4": "从电影中提取字幕",
        "notSupported": "您的浏览器不支持语音识别。请使用 Chrome、Edge 或 Safari。",
        "notAvailable": "语音控制不可用",
        "noSpeech": "未检测到语音。请重试。",
        "noMicrophone": "未检测到麦克风。请检查您的设备。",
        "microphoneBlocked": "麦克风访问被阻止。请在浏览器设置中启用。",
        "error": "语音识别错误：{{error}}",
        "startFailed": "启动语音识别失败。请重试。",
        "commandFailed": "执行命令失败。请重试。"
      },
      "schedules": {
        "title": "计划审计",
        "subtitle": "配置每日和每周审计计划",
        "dailyTitle": "每日审计",
        "weeklyTitle": "每周 AI 审计",
        "schedule": "计划",
        "time": "时间",
        "mode": "模式",
        "cost": "预估成本",
        "status": "状态",
        "description": "描述",
        "viewInConsole": "在云控制台中查看",
        "modifyNote": "要修改计划，请使用 Google Cloud Console",
        "editTitle": "编辑计划",
        "editNotAvailable": "计划编辑不可用",
        "editNotAvailableMessage": "计划修改需要 Cloud Scheduler API 集成。请使用「在云控制台中查看」按钮直接在 Google Cloud Console 中修改计划。",
        "cronExpression": "Cron 表达式",
        "cronHint": "格式：分 时 日 月 周（例如 0 2 * * * = 每天凌晨2:00）",
        "patterns": {
          "daily": "每天 {{hour}}:{{minute}}",
          "weekly": "每周{{day}} {{hour}}:{{minute}}"
        },
        "days": {
          "sunday": "星期日",
          "monday": "星期一",
          "tuesday": "星期二",
          "wednesday": "星期三",
          "thursday": "星期四",
          "friday": "星期五",
          "saturday": "星期六"
        }
      },
      "reports": {
        "title": "最近审计报告",
        "emptyMessage": "暂无审计报告",
        "totalReports": "{{count}} 份报告",
        "clearAll": "清除全部",
        "confirmClearAll": "确定要清除所有审计报告？此操作无法撤销。",
        "clearedSuccessfully": "所有审计报告清除成功",
        "viewLogs": "查看日志",
        "viewDetails": "查看详情",
        "columns": {
          "date": "日期",
          "type": "类型",
          "duration": "时长",
          "status": "状态",
          "issues": "问题",
          "fixes": "修复",
          "actions": "操作"
        },
        "detailModal": {
          "title": "审计报告：{{id}}",
          "summary": "摘要",
          "status": "状态",
          "executionTime": "执行时间",
          "totalItems": "总项目",
          "healthyItems": "健康项目",
          "issuesFound": "发现问题",
          "totalIssues": "发现的总问题",
          "seeInsightsBelow": "请查看下方的 AI 洞察了解详情",
          "brokenStreams": "损坏的流",
          "missingMetadata": "缺失元数据",
          "misclassifications": "错误分类",
          "orphanedItems": "孤立项目",
          "fixesApplied": "已应用修复",
          "totalFixes": "共 {{count}} 个修复",
          "aiInsights": "AI 洞察"
        }
      },
      "logs": {
        "title": "执行日志",
        "liveAuditLog": "实时审计日志",
        "executionLog": "审计执行日志",
        "searchPlaceholder": "搜索日志...",
        "noLogs": "无日志显示",
        "noActiveAudit": "无活跃审计",
        "triggerAuditToSee": "触发审计以查看实时执行日志",
        "auditType": "审计类型",
        "started": "开始",
        "completed": "完成",
        "lastLog": "最后日志",
        "staleWarning": "{{seconds}}秒无新日志 - 任务可能正在处理或卡住",
        "pollingStatus": "轮询活跃 • 上次检查",
        "connecting": "正在连接实时审计日志...",
        "aiInsightPrefix": "AI 洞察",
        "source": {
          "librarian": "管理员",
          "aiAgent": "AI 代理"
        },
        "levels": {
          "debug": "调试",
          "info": "信息",
          "warn": "警告",
          "error": "错误",
          "success": "成功",
          "trace": "跟踪"
        },
        "auditStarted": "审计已开始",
        "brokenStreamsFound": "发现 {{count}} 个损坏的流",
        "missingMetadataFound": "发现 {{count}} 个缺失元数据的项目",
        "misclassificationsFound": "发现 {{count}} 个错误分类的项目",
        "orphanedItemsFound": "发现 {{count}} 个孤立项目",
        "fixesApplied": "已应用 {{count}} 个修复",
        "auditCompleted": "审计 {{status}} 用时 {{duration}}秒",
        "auditInitializing": "正在初始化 {{auditType}} 审计...",
        "dryRunMode": "以预览模式运行 - 不会进行任何更改",
        "liveMode": "以实时模式运行 - 将应用更改",
        "budgetSet": "预算限制：${{budget}}",
        "connectingToAgent": "正在连接 Claude AI 代理..."
      },
      "audit": {
        "types": {
          "aiAgent": "AI 代理",
          "dailyIncremental": "每日增量"
        },
        "pause": "暂停",
        "resume": "恢复",
        "cancel": "取消",
        "interject": "插入消息",
        "interjectTitle": "向 AI 代理发送消息",
        "interjectHint": "此消息将在下一次迭代时注入到 AI 代理对话中。用于提供额外上下文、重定向焦点或给出特定指令。",
        "interjectPlaceholder": "例如：只关注电影，暂时跳过剧集...",
        "sendInterject": "发送",
        "interjectSuccess": "消息成功发送给 AI 代理",
        "pauseSuccess": "审计暂停成功",
        "resumeSuccess": "审计恢复成功",
        "cancelSuccess": "审计取消成功"
      },
      "progress": {
        "batch": "批次 {{current}}/{{total}}",
        "items": "{{processed}}/{{total}} 个项目",
        "finishing": "正在完成...",
        "finalizing": "正在生成报告并应用修复"
      },
      "activityLog": {
        "title": "活动日志",
        "subtitle": "已记录 {{count}} 个操作",
        "filterByType": "按类型筛选",
        "allActions": "所有操作",
        "content": "内容",
        "noDescription": "无可用描述",
        "updatedFields": "已更新 {{fields}}",
        "pagination": "第 {{page}} 页，共 {{totalPages}} 页",
        "issueType": "问题类型",
        "confidence": "置信度",
        "autoApproved": "自动批准",
        "changes": "更改",
        "actionTypes": {
          "addPoster": "添加海报",
          "updateMetadata": "更新元数据",
          "recategorize": "重新分类",
          "fixUrl": "修复 URL",
          "cleanTitle": "清理标题",
          "classify": "分类"
        },
        "rollback": "回滚",
        "rolledBack": "已回滚",
        "confirmRollback": {
          "title": "确认回滚",
          "message": "确定要回滚此操作？这将恢复之前的状态。"
        },
        "emptyMessage": "未找到操作"
      },
      "modal": {
        "confirmAI": {
          "title": "触发 AI 代理审计？",
          "message": "这将触发预算限制为 ${{budget}} 的自主 AI 代理审计。代理将决定检查和修复什么。{{dryRun}}",
          "dryRunNote": "以预览模式运行（不会进行任何更改）。"
        },
        "cancel": "取消",
        "confirm": "确认",
        "close": "关闭",
        "retry": "重试"
      },
      "status": {
        "enabled": "已启用",
        "disabled": "已禁用",
        "completed": "审计完成",
        "failed": "审计失败",
        "in_progress": "进行中",
        "partial": "部分完成",
        "pending": "待处理",
        "running": "运行中"
      },
      "auditTypes": {
        "daily_incremental": "每日增量",
        "ai_agent": "AI 代理"
      }
    },
    "widgets": {
      "title": "小组件",
      "subtitle": "管理直播流和嵌入的浮动覆盖小组件",
      "newWidget": "新建小组件",
      "editWidget": "编辑小组件",
      "columns": {
        "title": "标题",
        "contentType": "内容类型",
        "targetRoles": "目标角色",
        "targetPages": "目标页面",
        "status": "状态",
        "order": "顺序"
      },
      "contentTypes": {
        "liveChannel": "直播频道",
        "live": "直播",
        "vod": "点播视频",
        "podcast": "播客",
        "radio": "广播",
        "iframe": "Iframe"
      },
      "status": {
        "active": "活跃",
        "inactive": "未激活"
      },
      "form": {
        "title": "小组件标题",
        "description": "描述（可选）",
        "icon": "图标表情（可选）",
        "contentType": "内容类型",
        "selectChannel": "选择直播频道",
        "channelPlaceholder": "-- 选择频道 --",
        "iframeUrl": "Iframe 网址",
        "iframeTitle": "Iframe 标题（用于无障碍）",
        "position": "默认位置",
        "behavior": "行为",
        "mutedByDefault": "默认静音",
        "closable": "可关闭",
        "draggable": "可拖动",
        "targetPages": "目标页面（逗号分隔，留空=全部）",
        "targetPagesPlaceholder": "/、/live、/vod",
        "order": "顺序"
      },
      "actions": {
        "save": "保存",
        "cancel": "取消"
      },
      "confirmDelete": "确定要删除此小组件？",
      "emptyMessage": "未找到小组件。创建一个开始使用。",
      "allPages": "所有页面",
      "allRoles": "全部",
      "errors": {
        "titleRequired": "标题为必填项",
        "selectChannel": "请选择直播频道",
        "iframeUrlRequired": "Iframe URL 为必填项"
      }
    },
    "billing": {
      "subtitle": "跟踪收入和付款",
      "revenue": "收入",
      "today": "今日",
      "thisWeek": "本周",
      "thisMonth": "本月",
      "thisYear": "今年",
      "metrics": "关键指标",
      "totalTransactions": "总交易",
      "avgTransaction": "平均交易",
      "pendingRefunds": "待处理退款",
      "refundRate": "退款率",
      "retention": "留存",
      "retentionRate": "留存率",
      "churnRate": "流失率",
      "atRiskUsers": "风险用户",
      "churnedUsers": "流失用户",
      "quickLinks": "快捷链接"
    },
    "marketing": {
      "recentCampaigns": "最近活动",
      "audienceSegments": "受众细分",
      "emailMetrics": "邮件指标",
      "pushMetrics": "推送指标",
      "quickActions": "快捷操作"
    },
    "push": {
      "titlePlaceholder": "通知标题",
      "bodyPlaceholder": "通知消息"
    },
    "auditLogs": {
      "subtitle": "跟踪所有系统操作",
      "filter": "筛选",
      "export": "导出",
      "all": "全部",
      "advancedFiltering": "高级筛选",
      "actionType": "操作类型",
      "clear": "清除",
      "apply": "应用",
      "noRecords": "未找到记录",
      "columns": {
        "action": "操作",
        "user": "用户",
        "resource": "资源",
        "details": "详情",
        "date": "日期",
        "ip": "IP"
      },
      "changed": "已更改",
      "actionFilters": {
        "user": "用户",
        "subscription": "订阅",
        "payment": "付款",
        "settings": "设置",
        "campaign": "活动",
        "content": "内容"
      }
    },
    "settings": {
      "subtitle": "配置系统参数",
      "saveChanges": "保存更改",
      "generalSettings": "常规设置",
      "supportEmail": "支持邮箱",
      "defaultPlan": "默认套餐",
      "termsUrl": "服务条款 URL",
      "privacyUrl": "隐私政策 URL",
      "userSettings": "用户设置",
      "maxDevices": "每账户最大设备数",
      "trialDays": "试用期天数",
      "maintenanceMode": "维护模式",
      "maintenanceModeDesc": "启用后，系统将对用户不可访问",
      "featureFlags": "功能开关",
      "systemActions": "系统操作",
      "clearCache": "清除缓存",
      "resetAnalytics": "重置分析",
      "actionsWarning": "这些操作可能影响系统性能。请谨慎使用。",
      "savingSuccess": "设置保存成功",
      "confirmClearCache": "清除缓存？这可能暂时影响性能。",
      "cacheCleared": "缓存清除成功",
      "confirmResetAnalytics": "重置分析数据？此操作无法撤销！",
      "analyticsReset": "分析数据已重置",
      "featureFlagLabels": {
        "new_player": "新播放器",
        "live_chat": "实时聊天",
        "downloads": "下载",
        "watch_party": "观影派对",
        "voice_search": "语音搜索",
        "ai_recommendations": "AI 推荐"
      }
    },
    "content": {
      "title": "内容库",
      "subtitle": "管理电影、剧集和视频内容",
      "importFree": "导入免费内容",
      "searchPlaceholder": "搜索内容...",
      "emptyMessage": "未找到内容",
      "confirmDelete": "删除此内容？",
      "confirmBatchDelete": "确定要删除 {{count}} 个项目？",
      "selectedItems": "已选 {{count}} 个项目",
      "batchFeature": "设为精选",
      "batchUnfeature": "取消精选",
      "import": {
        "pageTitle": "导入免费内容",
        "subtitle": "浏览并导入免费来源的公共内容",
        "selectCategory": "为导入的电影选择分类：",
        "categoryPlaceholder": "选择分类...",
        "loading": "加载来源中...",
        "sourceTypes": {
          "vod": "电影与点播",
          "live_tv": "直播电视",
          "radio": "广播",
          "podcasts": "播客"
        },
        "items": "项目",
        "itemsPlural": "项目",
        "selectItems": "请至少选择一个项目导入",
        "selectCategory_vod": "请为点播导入选择分类",
        "importing": "正在导入 {{count}}... {{percent}}%",
        "importButton": "导入 {{count}} 个 {{item}}",
        "noSources": "无可用来源",
        "noSourcesDescription": "当前无 {{type}} 类型的免费内容来源"
      },
      "filters": {
        "title": "筛选",
        "contentType": "内容类型",
        "all": "全部",
        "allContent": "全部",
        "series": "剧集",
        "movies": "电影",
        "podcasts": "播客",
        "radioStations": "电台",
        "status": "状态",
        "allStatus": "所有状态",
        "subtitles": "字幕"
      },
      "podcastsComingSoon": "播客管理即将推出。请使用播客部分。",
      "radioComingSoon": "电台管理即将推出。请使用电台部分。",
      "showOnlyWithSubtitles": "仅显示有字幕的",
      "status": {
        "published": "已发布",
        "draft": "草稿"
      },
      "columns": {
        "title": "标题",
        "category": "分类",
        "year": "年份",
        "status": "状态",
        "views": "观看",
        "rating": "评分",
        "streamUrl": "流 URL",
        "epgSource": "EPG 来源",
        "genre": "类型",
        "episodeNumber": "集号",
        "description": "描述",
        "duration": "时长",
        "publishedDate": "发布日期",
        "episodes": "剧集",
        "order": "顺序",
        "name": "名称",
        "slug": "别名",
        "subtitles": "字幕"
      },
      "validation": {
        "titleRequired": "标题为必填项",
        "nameRequired": "名称为必填项",
        "streamUrlRequired": "流 URL 为必填项",
        "audioUrlRequired": "音频 URL 为必填项"
      },
      "episodes_one": "集",
      "episodes_other": "集",
      "noEpisodes": "未找到剧集",
      "type": {
        "series": "剧集",
        "movie": "电影"
      },
      "toggleCarousel": "切换轮播",
      "editor": {
        "pageTitle": "编辑内容",
        "pageTitleNew": "添加内容",
        "sections": {
          "basicInfo": "基本信息",
          "media": "媒体",
          "streaming": "流媒体",
          "details": "内容详情",
          "publishing": "发布",
          "accessControl": "访问控制",
          "podcastDetails": "播客详情",
          "episodeDetails": "剧集详情",
          "stationDetails": "电台详情",
          "channelDetails": "频道详情"
        },
        "fields": {
          "title": "标题",
          "titlePlaceholder": "内容标题",
          "titleRequired": "标题为必填项",
          "year": "年份",
          "yearPlaceholder": "2024",
          "description": "描述",
          "descriptionPlaceholder": "内容描述",
          "thumbnail": "缩略图（3:4 比例）",
          "thumbnailUrl": "缩略图 URL",
          "thumbnailUrlPlaceholder": "https://example.com/thumbnail.jpg",
          "backdrop": "背景图（16:9 比例）",
          "backdropUrl": "背景图 URL",
          "posterCover": "播客封面",
          "logo": "标志",
          "channelLogo": "频道标志",
          "stationLogo": "电台标志",
          "streamUrl": "流 URL",
          "streamUrlRequired": "流 URL 为必填项",
          "streamType": "流类型",
          "drmProtected": "DRM 保护",
          "drmProtectedLabel": "此内容需要 DRM 保护",
          "category": "分类",
          "categoryRequired": "分类为必填项",
          "duration": "时长",
          "durationPlaceholder": "1:30:00",
          "rating": "评级",
          "ratingPlaceholder": "PG-13",
          "genre": "类型",
          "genrePlaceholder": "剧情",
          "director": "导演",
          "directorPlaceholder": "导演姓名",
          "isSeries": "剧集",
          "isSeriesLabel": "这是一部剧集/多集内容",
          "season": "季",
          "episode": "集",
          "seriesId": "剧集 ID",
          "seriesIdPlaceholder": "series-identifier",
          "isPublished": "发布",
          "isPublishedLabel": "立即发布此内容",
          "isFeatured": "精选",
          "isFeaturedLabel": "在首页精选此内容",
          "requiresSubscription": "需要订阅",
          "isKidsContent": "儿童内容",
          "isKidsContentLabel": "这是适合儿童的内容",
          "author": "作者",
          "authorPlaceholder": "播客作者",
          "podcastCategory": "分类",
          "podcastCategoryPlaceholder": "新闻、科学等",
          "rssFeed": "RSS 订阅源 URL",
          "rssFeedPlaceholder": "https://example.com/feed.xml",
          "website": "网站 URL",
          "websitePlaceholder": "https://example.com",
          "episodeNumber": "集号",
          "seasonNumber": "季号",
          "audioUrl": "音频 URL",
          "audioUrlRequired": "音频 URL 为必填项",
          "audioUrlPlaceholder": "https://example.com/episode.mp3",
          "publishedAt": "发布日期",
          "epgSource": "EPG 来源 URL",
          "epgSourcePlaceholder": "https://example.com/epg.xml",
          "currentShow": "当前节目",
          "currentShowPlaceholder": "节目名称",
          "nextShow": "下一节目",
          "nextShowPlaceholder": "节目名称",
          "currentSong": "当前歌曲",
          "currentSongPlaceholder": "歌曲标题",
          "isActive": "活跃",
          "isActiveLabel": "频道已激活",
          "requiredSubscription": "需要订阅",
          "publishedDate": "发布日期"
        },
        "subscriptionTiers": {
          "basic": "基础版",
          "premium": "高级版",
          "family": "家庭版"
        },
        "actions": {
          "save": "保存",
          "saving": "保存中...",
          "cancel": "取消"
        },
        "imageUpload": {
          "dropHere": "拖放图片到此处或点击上传",
          "formats": "PNG、JPG、WebP，最大 {{maxSize}}MB",
          "uploading": "上传中...",
          "success": "图片上传成功",
          "orPasteUrl": "或粘贴图片 URL",
          "urlPlaceholder": "https://example.com/image.jpg",
          "validateButton": "添加",
          "validating": "验证中...",
          "clear": "移除图片",
          "errors": {
            "imageOnly": "请选择图片文件",
            "tooLarge": "文件大小必须小于 {{maxSize}}MB",
            "uploadFailed": "上传失败",
            "invalidUrl": "无效的 URL"
          }
        }
      },
      "categoryPicker": {
        "selectPlaceholder": "选择分类...",
        "searchPlaceholder": "搜索分类...",
        "loading": "加载分类中...",
        "noResults": "未找到分类",
        "noCategories": "无可用分类",
        "createNew": "创建新分类",
        "errors": {
          "loadFailed": "加载分类失败",
          "createFailed": "创建分类失败"
        },
        "modal": {
          "title": "创建新分类",
          "placeholder": "分类名称（如电影、剧集）",
          "creating": "创建中...",
          "create": "创建"
        }
      },
      "streamUrlInput": {
        "copyUrl": "复制 URL",
        "copied": "URL 已复制到剪贴板",
        "streamType": "流类型",
        "validUrl": "URL 有效 - 检测为 {{type}}",
        "errors": {
          "required": "流 URL 为必填项",
          "invalidFormat": "无效的 URL 格式"
        },
        "supportedFormats": {
          "title": "支持的格式：",
          "hls": "HLS：.m3u8 流",
          "dash": "DASH：.mpd 流",
          "audio": "音频：.mp3、.aac 或音频流"
        }
      }
    },
    "categories": {
      "subtitle": "管理内容分类",
      "emptyMessage": "未找到分类",
      "status": {
        "active": "活跃",
        "inactive": "未激活"
      },
      "form": {
        "nameHebrew": "分类名称（希伯来文）",
        "nameEnglish": "分类名称（英文）",
        "slug": "别名"
      }
    },
    "liveChannels": {
      "subtitle": "管理直播电视频道",
      "emptyMessage": "未找到直播频道",
      "subtitleSettings": "实时字幕设置",
      "form": {
        "name": "频道名称",
        "streamUrl": "流 URL",
        "epgSource": "EPG 来源 URL（可选）",
        "currentShow": "当前节目",
        "order": "顺序",
        "supportsSubtitles": "启用实时字幕",
        "primaryLanguage": "主要语言（来源）",
        "targetLanguages": "可用翻译语言",
        "targetLanguagesHelp": "选择用户可以实时翻译的语言"
      }
    },
    "radioStations": {
      "subtitle": "管理电台",
      "emptyMessage": "未找到电台",
      "form": {
        "name": "电台名称",
        "genre": "类型",
        "streamUrl": "流 URL",
        "currentShow": "当前节目（可选）",
        "currentSong": "当前歌曲（可选）",
        "order": "顺序"
      }
    },
    "podcasts": {
      "subtitle": "管理播客和剧集",
      "episodesSubtitle": "管理剧集",
      "emptyMessage": "未找到播客",
      "noEpisodes": "未找到剧集",
      "form": {
        "title": "播客标题",
        "author": "作者",
        "description": "描述",
        "category": "分类",
        "rssFeed": "RSS 订阅源 URL",
        "website": "网站 URL（可选）"
      },
      "episodes": {
        "form": {
          "title": "剧集标题",
          "description": "描述",
          "episodeNumber": "集号",
          "seasonNumber": "季号（可选）",
          "duration": "时长",
          "audioUrl": "音频 URL（必填）",
          "publishedDate": "发布日期（YYYY-MM-DD）"
        }
      }
    },
    "users": {
      "subtitle": "管理用户和账户",
      "addUser": "添加用户",
      "status": {
        "active": "活跃",
        "inactive": "未激活",
        "blocked": "已封禁"
      },
      "filters": {
        "all": "全部",
        "active": "活跃",
        "inactive": "未激活",
        "blocked": "已封禁"
      },
      "columns": {
        "name": "姓名",
        "role": "角色",
        "subscription": "订阅",
        "noSubscription": "无订阅",
        "status": "状态",
        "created": "创建日期",
        "actions": "操作"
      },
      "confirmDelete": "删除用户",
      "confirmDeleteMessage": "确定要删除 {{name}}？此操作无法撤销。",
      "resetPassword": "重置密码",
      "block": "封禁",
      "unban": "解封",
      "confirmResetPassword": "向 {{email}} 发送密码重置邮件？",
      "resetPasswordSent": "密码重置邮件已发送",
      "recentActivity": "最近活动",
      "noActivity": "无活动",
      "notFound": "用户未找到",
      "backToList": "返回列表",
      "banReason": "封禁原因",
      "banReasonPrompt": "封禁原因：",
      "confirmUnban": "解封用户？",
      "userDetails": "用户详情",
      "id": "ID",
      "registered": "注册日期",
      "billingHistory": "账单历史",
      "noPayments": "无付款记录"
    },
    "campaigns": {
      "subtitle": "管理优惠码和折扣",
      "expired": "已过期",
      "status": {
        "active": "活跃",
        "inactive": "未激活"
      },
      "columns": {
        "name": "名称",
        "discount": "折扣",
        "usage": "使用次数",
        "validUntil": "有效期至",
        "status": "状态",
        "actions": "操作"
      },
      "confirmDelete": "删除活动",
      "confirmDeleteMessage": "确定要删除 \"{{name}}\"？此操作无法撤销。",
      "searchPlaceholder": "搜索活动...",
      "emptyMessage": "未找到活动",
      "deactivate": "停用",
      "activate": "激活",
      "createTitle": "新建活动",
      "editTitle": "编辑活动",
      "formSubtitle": "设置优惠码或折扣",
      "form": {
        "name": "活动名称",
        "namePlaceholder": "例如：2024年夏季促销",
        "code": "优惠码",
        "generate": "生成",
        "discountType": "折扣类型",
        "discountValue": "折扣值",
        "maxUses": "最大使用次数",
        "unlimited": "无限制",
        "validUntil": "有效期至",
        "active": "活动已激活"
      }
    },
    "subscriptions": {
      "subtitle": "查看和管理系统订阅者",
      "status": {
        "active": "活跃",
        "paused": "已暂停",
        "cancelled": "已取消",
        "expired": "已过期"
      },
      "columns": {
        "user": "用户",
        "plan": "套餐",
        "price": "价格",
        "nextBilling": "下次计费",
        "status": "状态"
      },
      "perMonth": "/月",
      "searchPlaceholder": "搜索订阅...",
      "emptyMessage": "未找到订阅",
      "actions": {
        "changePlan": "更改套餐",
        "pause": "暂停",
        "resume": "恢复",
        "cancel": "取消",
        "delete": "删除"
      },
      "editPlan": {
        "title": "更改订阅套餐",
        "user": "用户",
        "currentPlan": "当前套餐",
        "newPlan": "选择新套餐"
      },
      "addSubscription": {
        "title": "添加订阅",
        "userEmail": "用户邮箱",
        "emailPlaceholder": "输入用户邮箱",
        "duration": "时长（天）",
        "selectPlan": "选择套餐"
      },
      "fillAllFields": "请填写所有字段",
      "userNotFound": "用户未找到",
      "selectOneToEdit": "请选择一个订阅进行编辑",
      "selectToDelete": "请选择要删除的订阅",
      "confirmDeleteMultiple": "删除 {{count}} 个订阅？",
      "selected": "已选",
      "confirmDelete": "确定要删除 {{user}} 的订阅？此操作无法撤销。"
    },
    "marketingDashboard": {
      "subtitle": "营销概览",
      "refresh": "刷新",
      "totalSubscribers": "总订阅者",
      "emailOpenRate": "邮件打开率",
      "pushClickRate": "推送点击率",
      "activeSegments": "活跃细分",
      "campaignStatus": {
        "active": "活跃",
        "completed": "已完成",
        "scheduled": "已计划",
        "draft": "草稿"
      }
    },
    "transactions": {
      "subtitle": "查看付款历史",
      "exportCsv": "导出 CSV",
      "status": {
        "completed": "已完成",
        "pending": "待处理",
        "failed": "失败",
        "refunded": "已退款"
      },
      "columns": {
        "id": "ID",
        "user": "用户",
        "amount": "金额",
        "type": "类型",
        "status": "状态",
        "date": "日期"
      },
      "filters": {
        "all": "全部"
      },
      "searchPlaceholder": "搜索交易...",
      "emptyMessage": "未找到交易",
      "details": "交易详情",
      "email": "邮箱"
    },
    "pushNotifications": {
      "subtitle": "创建并向用户发送通知",
      "newNotification": "新建通知",
      "status": {
        "draft": "草稿",
        "sent": "已发送",
        "scheduled": "已计划"
      },
      "columns": {
        "title": "标题",
        "status": "状态",
        "sent": "已发送",
        "opened": "已打开",
        "scheduledAt": "计划时间",
        "created": "创建日期",
        "actions": "操作"
      },
      "filters": {
        "all": "全部"
      },
      "searchPlaceholder": "搜索通知...",
      "emptyMessage": "未找到通知",
      "createModal": "新建推送通知",
      "editModal": "编辑通知",
      "scheduleModal": "计划通知",
      "titleLabel": "标题",
      "bodyLabel": "内容",
      "dateTimeLabel": "日期和时间",
      "cancel": "取消",
      "create": "创建通知",
      "schedule": "计划",
      "send": "立即发送",
      "confirmSend": "发送通知 \"{{title}}\"？",
      "confirmDelete": "删除通知 \"{{title}}\"？",
      "fillRequired": "请填写标题和内容"
    }
  },
  "placeholder": {
    "email": "your@email.com",
    "password": "••••••••",
    "pin": "••••",
    "dateRange": {
      "from": "从（YYYY-MM-DD）",
      "to": "到（YYYY-MM-DD）"
    },
    "amount": {
      "min": "最小",
      "max": "最大",
      "price": "0.00"
    },
    "chatMessage": "在此输入...",
    "deepLink": "bayitplus://content/123",
    "scheduleDateTime": "YYYY-MM-DDTHH:mm",
    "roomCode": "ABCD1234",
    "time": {
      "start": "08:00",
      "end": "10:00"
    },
    "filter": {
      "userId": "输入用户 ID"
    },
    "datetime": "YYYY-MM-DDTHH:mm",
    "number": "0",
    "chat": "输入您的消息..."
  },
  "components": {
    "select": {
      "default": "选择..."
    }
  },
  "plans": {
    "basic": {
      "name": "基础版",
      "features": [
        "所有点播内容",
        "广播与播客",
        "1台设备观看",
        "标清画质"
      ],
      "notIncluded": [
        "直播频道",
        "AI 助手",
        "离线观看"
      ]
    },
    "premium": {
      "name": "高级版",
      "features": [
        "所有点播内容",
        "直播频道",
        "广播与播客",
        "智能 AI 助手",
        "2台设备观看",
        "高清画质"
      ],
      "notIncluded": [
        "离线观看",
        "家庭档案"
      ]
    },
    "family": {
      "name": "家庭版",
      "features": [
        "所有点播内容",
        "直播频道",
        "广播与播客",
        "智能 AI 助手",
        "4台设备观看",
        "4K 画质",
        "5个家庭档案",
        "离线下载"
      ],
      "notIncluded": []
    },
    "batchActions": {
      "selectedCount": "已选择 {{count}} 项",
      "selectedCount_one": "已选择 {{count}} 项",
      "selectedCount_other": "已选择 {{count}} 项",
      "clear": "清除"
    },
    "costDashboard": {
      "title": "成本仪表板",
      "costBreakdown": "成本明细",
      "loadingBreakdown": "加载明细中...",
      "aiCosts": "AI 成本",
      "infrastructure": "基础设施",
      "thirdParty": "第三方",
      "thirdPartyApis": "第三方 API",
      "translation": "翻译",
      "search": "搜索",
      "percentOfTotal": "% 总计",
      "components": "组件",
      "topSpenders": {
        "title": "月度消费前20名",
        "loading": "加载消费排名...",
        "rank": "排名",
        "userId": "用户ID",
        "costRange": "成本范围",
        "privacyNote": "用户ID已加密，成本按范围汇总以保护隐私。"
      },
      "categories": {
        "permanent": "固定",
        "transient": "可变",
        "permanentVsTransient": "固定 vs 可变",
        "permanentFixed": "固定 (基础设施)",
        "transientVariable": "可变 (使用量)",
        "permanentDesc": "每月发生的基础设施成本，与使用量无关",
        "transientDesc": "随平台活动波动的基于使用量的成本",
        "detailedBreakdown": "详细明细",
        "costItem": "成本项目",
        "category": "类别",
        "amount": "金额"
      },
      "timeline": {
        "title": "成本时间线",
        "loading": "加载时间线...",
        "amountLabel": "金额 ($)",
        "revenue": "收入",
        "totalCost": "总成本",
        "netProfit": "净利润",
        "showingData": "显示 {{start}} 至 {{end}} 的数据"
      },
      "plSummary": {
        "netProfitLoss": "净利润/亏损",
        "margin": "利润率",
        "revenue": "收入",
        "totalCosts": "总成本"
      }
    }
  },
  "subscribe": {
    "title": "选择您的套餐",
    "subtitle": "任何套餐7天免费试用。随时取消。",
    "monthly": "月付",
    "yearly": "年付",
    "save2Months": "省2个月",
    "popular": "最受欢迎",
    "period": "/月",
    "perYear": "/年",
    "select": "选择套餐",
    "selected": "已选择",
    "processing": "处理中...",
    "startTrial": "开始免费试用",
    "noCharge": "试用期间不会收取您的信用卡费用"
  },
  "notFound": {
    "title": "页面未找到",
    "description": "您查找的页面不存在或已被移动。",
    "homeButton": "返回首页",
    "searchButton": "搜索",
    "orTry": "或者尝试：",
    "liveChannel": "直播",
    "vodLabel": "电影",
    "podcastsLabel": "播客"
  },
  "profiles": {
    "addProfile": "添加档案",
    "enterPin": "输入 PIN",
    "selectError": "选择档案出错",
    "wrongPin": "PIN 不正确",
    "loading": "加载档案中...",
    "manage": "管理档案",
    "whoIsWatching": "谁在观看？",
    "manageProfiles": "管理档案",
    "kids": "儿童",
    "addIcon": "+"
  },
  "watch": {
    "notFound": "未找到内容",
    "backToHome": "返回首页",
    "episodes": "剧集",
    "addToList": "添加到列表",
    "like": "喜欢",
    "share": "分享",
    "cast": "演员",
    "episodesList": "剧集",
    "schedule": "时间表",
    "now": "现在",
    "related": "相关内容",
    "deleteEpisode": "删除剧集",
    "confirmDeleteEpisode": "删除此剧集？"
  },
  "live": {
    "title": "直播电视",
    "next": "下一个：",
    "noChannels": "无可用频道",
    "tryLater": "请稍后重试",
    "categories": {
      "all": "全部",
      "news": "新闻",
      "entertainment": "娱乐",
      "sports": "体育",
      "kids": "儿童",
      "music": "音乐"
    }
  },
  "judaism": {
    "title": "犹太教",
    "items": "项目",
    "empty": "无可用内容",
    "emptyHint": "尝试选择其他分类",
    "dashboard": "您的犹太教仪表板",
    "categories": {
      "news": "犹太新闻",
      "community": "社区"
    },
    "shabbat": {
      "title": "安息日时间",
      "shabbatShalom": "安息日平安！",
      "shabbatMode": "安息日模式",
      "endsIn": "安息日结束于",
      "candleLighting": "点蜡烛",
      "havdalah": "哈夫达拉",
      "parashat": "每周圣经",
      "friday": "星期五",
      "saturday": "星期六",
      "noData": "无法加载安息日时间"
    },
    "erevShabbat": {
      "title": "安息日前夜",
      "prepareFor": "准备安息日",
      "inTime": "{{time}} 后",
      "featuredContent": "安息日内容",
      "noContent": "安息日内容即将推出！",
      "shabbatShalom": "安息日平安！",
      "timeUntil": "距安息日时间",
      "shabbatSongs": "安息日歌曲",
      "parashaStudy": "每周圣经",
      "shabbatRecipes": "食谱",
      "prayers": "祈祷"
    }
  },
  "children": {
    "title": "儿童",
    "items": "项目",
    "empty": "无可用内容",
    "emptyHint": "尝试其他分类",
    "exitKidsMode": "退出儿童模式",
    "exitDescription": "输入家长代码以退出",
    "parentCode": "家长代码",
    "confirm": "确认",
    "wrongCode": "代码不正确",
    "noContent": "无可用内容",
    "tryAnotherCategory": "尝试选择其他分类",
    "categories": {
      "all": "全部",
      "cartoons": "动画片",
      "educational": "教育",
      "music": "音乐",
      "hebrew": "希伯来语",
      "stories": "故事",
      "jewish": "犹太"
    },
    "ageRatings": {
      "3": "3岁以上",
      "5": "5岁以上",
      "7": "7岁以上",
      "10": "10岁以上",
      "12": "12岁以上"
    },
    "moderation": {
      "pending": "待审核",
      "approved": "已批准",
      "rejected": "已拒绝"
    },
    "admin": {
      "stats": "儿童内容管理器",
      "seedContent": "导入内容",
      "importArchive": "导入 Archive.org",
      "syncPodcasts": "同步播客",
      "syncYouTube": "同步 YouTube",
      "tagVod": "标记点播",
      "pendingModeration": "待审核"
    }
  },
  "youngsters": {
    "title": "[zh] Youngsters",
    "items": "[zh] items",
    "empty": "[zh] No content available",
    "emptyHint": "[zh] Try another category",
    "exitYoungstersMode": "[zh] Exit Youngsters Mode",
    "exitDescription": "[zh] Enter parent code to exit",
    "parentCode": "[zh] Parent code",
    "confirm": "[zh] Confirm",
    "wrongCode": "[zh] Incorrect code",
    "noContent": "[zh] No content available",
    "tryAnotherCategory": "[zh] Try selecting another category",
    "categories": {
      "all": "[zh] All",
      "trending": "[zh] Trending",
      "news": "[zh] News",
      "culture": "[zh] Culture",
      "educational": "[zh] Educational",
      "music": "[zh] Music",
      "entertainment": "[zh] Entertainment",
      "sports": "[zh] Sports",
      "tech": "[zh] Technology",
      "judaism": "[zh] Judaism"
    },
    "ageGroups": {
      "middle-school": "[zh] Middle School (12-14)",
      "high-school": "[zh] High School (15-17)"
    },
    "moderation": {
      "pending": "[zh] Pending Review",
      "approved": "[zh] Approved",
      "rejected": "[zh] Rejected"
    },
    "admin": {
      "stats": "[zh] Youngsters Content Manager",
      "seedContent": "[zh] Seed Content",
      "importArchive": "[zh] Import Archive.org",
      "syncPodcasts": "[zh] Sync Podcasts",
      "syncYouTube": "[zh] Sync YouTube",
      "tagVod": "[zh] Tag VOD",
      "pendingModeration": "[zh] Pending Moderation"
    }
  },
  "chatbot": {
    "title": "Bayit+ 助手",
    "greeting": "您好！我是 Bayit+ 智能助手。今天我能为您做什么？点击麦克风说话，或输入消息。",
    "openChat": "打开聊天",
    "welcome": "您好！我是 Bayit+ 智能助手。今天我能为您做什么？点击麦克风说话，或输入消息。",
    "placeholder": "在此输入...",
    "recording": "录音中...再次点击停止",
    "transcribing": "转录中...",
    "stopRecording": "停止录音",
    "startRecording": "开始语音录音",
    "recommendations": "以下是一些推荐：",
    "showMultipleSuccess": "在小组件中显示 {{count}} 个内容项目",
    "showMultipleNotFound": "无法找到请求的内容。请尝试不同的名称。",
    "resolvingContent": "正在查找您的内容...",
    "errors": {
      "micPermission": "无法访问麦克风。请在浏览器中检查麦克风权限。",
      "transcribeFailed": "无法转录录音。请重试。",
      "general": "抱歉，出现问题。请重试。"
    },
    "suggestions": {
      "whatToWatch": "今天看什么？",
      "israeliMovies": "推荐的以色列电影",
      "whatsOnNow": "现在播放什么？",
      "popularPodcasts": "热门播客"
    },
    "voiceCommands": {
      "showChannels": "显示频道...",
      "playChess": "开始国际象棋游戏...",
      "multiContent": "并排显示..."
    }
  },
  "chat": {
    "title": "Bayit+ 助手",
    "greeting": "您好！我是 Bayit+ 智能助手。今天我能为您做什么？点击麦克风说话，或输入消息。"
  },
  "subtitles": {
    "nikud": "尼库德",
    "selection": "选择",
    "translation": "翻译",
    "translating": "翻译中...",
    "close": "关闭",
    "unavailable": "不可用",
    "off": "关闭",
    "none": "无",
    "autoGenerated": "自动生成",
    "selectLanguage": "选择字幕语言",
    "liveTranslate": "实时翻译",
    "translateTo": "翻译为",
    "downloadMore": "下载更多字幕...",
    "downloading": "正在搜索 OpenSubtitles...",
    "opensubtitlesSource": "来自 OpenSubtitles.com",
    "downloadSuccess": "已下载 {{count}} 个字幕",
    "noSubtitlesFound": "未找到此内容的字幕",
    "smartSubs": "智能字幕",
    "smartSubsDescription": "双视图：简化希伯来语 + 英语，带词根高亮",
    "smartSubsDualView": "双视图",
    "shoreshToggle": "词根高亮",
    "shoreshOn": "Shoresh 高亮已启用",
    "shoreshOff": "Shoresh 高亮已禁用",
    "nikudLive": "带 Nikud 的希伯来语",
    "nikudLiveDescription": "带变音符号的希伯来语字幕，便于阅读",
    "nikudEnabled": "Nikud 字幕已启用",
    "nikudDisabled": "Nikud 字幕已禁用",
    "nikudSubtitleLabel": "带 nikud 的希伯来语：{{text}}",
    "available": "字幕",
    "clickToEnable": "点击启用实时翻译",
    "connectionError": "实时翻译错误",
    "inputLanguageTooltip": "检查输入语言",
    "premiumRequired": "需要高级订阅",
    "selectInputLanguage": "选择输入语言",
    "translateActive": "实时翻译已激活",
    "noEnglishSubtitles": "此内容没有可用的英语字幕。",
    "hebrewMode": {
      "title": "希伯来语显示模式",
      "unavailable": "不可用",
      "generate": "生成",
      "regular": {
        "title": "普通希伯来语",
        "description": "不带元音符号的标准希伯来语文本"
      },
      "nikud": {
        "title": "带 Nikud 的希伯来语",
        "description": "带元音符号的希伯来语，便于阅读",
        "unavailableReason": "此内容无法进行 AI 处理"
      },
      "shoresh": {
        "title": "Shoresh（词根）",
        "description": "带词根分析的希伯来语单词：单词 [词根]",
        "unavailableReason": "此内容无法进行词根分析"
      }
    },
    "englishMode": {
      "title": "英语显示模式",
      "unavailable": "不可用",
      "generate": "生成",
      "firstTimeHint": "这些 AI 驱动的模式帮助您在学习英语句子结构的同时保持希伯来语。每种模式都提供独特的学习体验。",
      "regular": {
        "title": "普通英语",
        "description": "标准英语字幕"
      },
      "heblish": {
        "title": "希伯来英语混合",
        "description": "带希伯来语词汇注入的英语，实现沉浸式学习",
        "unavailableReason": "此内容无法进行 Heblish 处理"
      },
      "grammarFlip": {
        "title": "语法翻转",
        "description": "希伯来语词汇配合英语句子结构（主语-动词-宾语）",
        "unavailableReason": "此内容无法进行 Grammar-Flip 处理"
      },
      "slangSynthesis": {
        "title": "俚语合成",
        "description": "现代以色列和美国俚语混合，内容更加生动",
        "unavailableReason": "此内容无法进行 Slang Synthesis 处理"
      }
    },
    "loading": "加载字幕中...",
    "error": {
      "title": "字幕错误",
      "retry": "重试",
      "loadFailed": "加载字幕失败",
      "cuesFailed": "加载字幕文本失败",
      "networkError": "网络错误 - 请检查您的连接",
      "serverError": "服务器错误 - 请稍后重试"
    },
    "aiModesAvailable": "可用的 AI 模式",
    "aiModesTitle": "AI 字幕模式",
    "fetchSubtitles": "获取字幕",
    "fontSize": "字体大小",
    "mode": {
      "engrew": "英希混合",
      "heblish": "希伯来英语混合",
      "shoresh": "词根",
      "standard": "标准"
    },
    "opensubtitles": "OpenSubtitles",
    "searchExternal": "搜索外部字幕",
    "settingsTitle": "字幕设置",
    "showBackground": "显示背景",
    "singleMode": "单一模式",
    "splitMode": "分割模式",
    "primary_language": "主要语言",
    "secondary_language": "次要语言",
    "layout_mode": "布局模式",
    "interactive_title": "交互式字幕"
  },
  "video": {
    "watchTrailer": "观看预告片",
    "closeTrailer": "关闭预告片",
    "deleteConfirm": "删除此剧集？"
  },
  "recordings": {
    "title": "我的录制",
    "subtitle": "查看和管理您录制的直播流",
    "record": "录制",
    "recording": "录制中",
    "storageUsed": "已用存储",
    "totalRecordings": "总录制数",
    "maxDuration": "最长时长",
    "noRecordings": "暂无录制",
    "noRecordingsHint": "从任何直播频道开始录制！",
    "confirmDelete": "确定要删除此录制？此操作无法撤销。",
    "deleteRecording": "删除录制",
    "deleteFailed": "删除录制失败",
    "expires": "过期",
    "subtitlesAvailable": "可用字幕",
    "recordingSaved": "录制已保存！",
    "savedSuccess": "录制保存成功！时长：{{duration}}",
    "viewInMyRecordings": "在我的录制中查看",
    "error": "录制错误",
    "startFailed": "启动录制失败。请重试。",
    "stopFailed": "停止录制失败。请重试。",
    "page": "页"
  },
  "chess": {
    "title": "国际象棋",
    "welcome": "欢迎来到国际象棋",
    "subtitle": "与世界各地的朋友和家人下棋",
    "createGame": "创建新游戏",
    "joinGame": "加入游戏",
    "gameCode": "游戏代码",
    "enterGameCode": "输入游戏代码",
    "invalidGameCode": "无效的游戏代码。必须为6个字符。",
    "joinFailed": "加入游戏失败",
    "join": "加入",
    "create": "创建",
    "chooseColor": "选择您的颜色",
    "white": "白方",
    "black": "黑方",
    "chatPlaceholder": "输入消息...（@bot 获取建议）",
    "botHint": "在消息中标记 @bot 以从我们的 AI 助手获取国际象棋建议",
    "bot": "国际象棋助手",
    "mute": "静音",
    "unmute": "取消静音",
    "speaking": "参与者",
    "resign": "认输",
    "offerDraw": "提议和棋",
    "newGame": "新游戏",
    "checkmate": "将死！",
    "stalemate": "僵局",
    "draw": "和棋",
    "resigned": "已认输",
    "reconnecting": "重新连接中...",
    "moveHistory": "走棋历史",
    "noMoves": "暂无走棋",
    "showHints": "显示指南提示",
    "yourTurn": "轮到您",
    "opponentTurn": "对手回合",
    "waitingForOpponent": "等待对手...",
    "gameOver": "游戏结束",
    "sendingInvite": "正在向 {{name}} 发送游戏邀请...",
    "inviteSent": "游戏邀请已发送给 {{name}}！游戏代码：{{code}}",
    "inviteFailed": "找不到该用户。请检查名称后重试。",
    "inviteReceived": "{{name}} 邀请您下国际象棋！",
    "joinInvite": "加入游戏",
    "challenge": "挑战",
    "playedAsWhite": "执白",
    "playedAsBlack": "执黑",
    "gameMode": "游戏模式",
    "playVsFriend": "对战好友",
    "playVsBot": "对战机器人",
    "difficulty": "难度",
    "easy": "简单",
    "medium": "中等",
    "hard": "困难",
    "chessBot": "国际象棋机器人",
    "chat": {
      "title": "聊天",
      "inputPlaceholder": "输入消息..."
    },
    "acceptDraw": "[zh] Accept Draw",
    "acceptInvite": "[zh] Accept Invite",
    "blackCaptured": "[zh] Black Captured",
    "blackTurn": "[zh] Black's Turn",
    "challengeFriend": "[zh] Challenge Friend",
    "challengeViaWhatsApp": "[zh] Challenge via WhatsApp",
    "copyCode": "[zh] Copy Code",
    "declineDraw": "[zh] Decline Draw",
    "declineInvite": "[zh] Decline Invite",
    "drawOffered": "[zh] Draw Offered",
    "joinByGameCode": "[zh] Join by Game Code",
    "noFriendsYet": "[zh] No friends yet",
    "offline": "[zh] Offline",
    "online": "[zh] Online",
    "opponent": "[zh] Opponent",
    "whiteCaptured": "[zh] White Captured",
    "whiteTurn": "[zh] White's Turn",
    "you": "[zh] You"
  },
  "friends": {
    "title": "好友与对手",
    "subtitle": "与玩家联系并挑战好友",
    "myFriends": "我的好友",
    "requests": "请求",
    "findPlayers": "查找玩家",
    "friendsLabel": "好友",
    "pendingLabel": "待处理",
    "add": "添加好友",
    "remove": "移除",
    "accept": "接受",
    "reject": "拒绝",
    "cancel": "取消",
    "noFriends": "暂无好友",
    "noFriendsDesc": "搜索玩家并发送好友请求",
    "lastGame": "上次游戏：{{time}}",
    "friendsSince": "好友自 {{date}}",
    "incomingRequests": "收到的请求",
    "outgoingRequests": "发出的请求",
    "noIncoming": "无收到的请求",
    "noOutgoing": "无发出的请求",
    "sentAt": "发送于 {{time}}",
    "searchPlaceholder": "按名称搜索...",
    "noResults": "未找到玩家",
    "noResultsDesc": "尝试搜索其他名称",
    "requestSent": "好友请求已发送！",
    "requestAccepted": "好友请求已接受！",
    "requestRejected": "好友请求已拒绝",
    "requestCancelled": "好友请求已取消",
    "friendRemoved": "好友已移除",
    "searchFailed": "搜索用户失败",
    "requestFailed": "发送请求失败",
    "acceptFailed": "接受请求失败",
    "rejectFailed": "拒绝请求失败",
    "cancelFailed": "取消请求失败",
    "removeFailed": "移除好友失败",
    "friendsCount": "{{count}} 个好友",
    "gamesCount": "{{count}} 场游戏",
    "alreadyFriends": "好友"
  },
  "stats": {
    "statistics": "统计",
    "matchHistory": "比赛历史",
    "headToHead": "正面交锋",
    "gamesPlayed": "已玩游戏",
    "wins": "胜",
    "losses": "负",
    "draws": "和",
    "winRate": "胜率",
    "rating": "评分",
    "peakRating": "最高评分",
    "peak": "最高",
    "winStreak": "连胜",
    "currentStreak": "当前连胜",
    "bestStreak": "最佳连胜",
    "performance": "表现",
    "achievements": "成就",
    "currentRating": "当前评分",
    "totalGames": "总游戏数",
    "noGames": "暂无游戏记录",
    "moves": "步",
    "won": "胜",
    "lost": "负",
    "draw": "和",
    "overall": "总战绩",
    "yourWins": "您的胜场",
    "theirWins": "对方胜场",
    "totalGamesPlayed": "总计：{{count}} 场游戏",
    "recentGames": "最近游戏"
  },
  "support": {
    "title": "支持中心",
    "subtitle": "今天我们能帮您什么？",
    "tabs": {
      "docs": "文档",
      "faq": "常见问题",
      "contact": "联系",
      "tickets": "我的工单"
    },
    "categories": {
      "title": "浏览文档",
      "loading": "加载文档中...",
      "loadError": "加载分类失败",
      "articleCount": "{{count}} 篇文章",
      "gettingStarted": "入门",
      "features": "功能",
      "troubleshooting": "故障排除",
      "account": "账户"
    },
    "docs": {
      "loading": "加载文档中...",
      "loadError": "加载文档失败",
      "backToList": "返回文档列表"
    },
    "search": {
      "placeholder": "搜索文档...",
      "noResults": "未找到结果"
    },
    "faq": {
      "title": "常见问题",
      "loading": "加载常见问题...",
      "loadError": "加载常见问题失败",
      "empty": "此分类暂无常见问题",
      "categories": {
        "all": "所有话题",
        "general": "综合",
        "billing": "账单",
        "technical": "技术",
        "features": "功能"
      }
    },
    "contact": {
      "voiceTitle": "语音支持",
      "voiceDescription": "点击头像按钮或说 \"Jarvis\" 开始与我们的 AI 助手语音对话。",
      "ticketTitle": "创建支持工单",
      "ticketDescription": "需要人工帮助？创建支持工单，我们的团队将在24小时内回复。",
      "createTicket": "创建工单",
      "emailTitle": "邮件支持",
      "emailDescription": "更喜欢邮件？如有任何问题或疑虑，请联系 support@bayit.tv。"
    },
    "ticket": {
      "title": "创建支持工单",
      "subject": "主题",
      "subjectPlaceholder": "问题的简要描述",
      "message": "消息",
      "messagePlaceholder": "详细描述您的问题...",
      "categoryLabel": "分类",
      "priorityLabel": "优先级",
      "submit": "提交工单",
      "category": {
        "billing": "账单",
        "technical": "技术",
        "feature": "功能请求",
        "general": "综合"
      },
      "priority": {
        "low": "低",
        "medium": "中",
        "high": "高",
        "urgent": "紧急"
      },
      "status": {
        "open": "待处理",
        "in_progress": "处理中",
        "resolved": "已解决",
        "closed": "已关闭"
      },
      "created": "已创建",
      "error": {
        "required": "请填写所有必填字段",
        "submit": "创建工单失败。请重试。"
      }
    },
    "tickets": {
      "title": "我的支持工单",
      "loading": "加载工单中...",
      "loadError": "加载工单失败",
      "empty": "暂无支持工单",
      "emptyFilter": "无此状态的工单",
      "create": "新工单",
      "createFirst": "创建您的第一个工单",
      "filter": {
        "all": "全部",
        "open": "待处理",
        "inProgress": "处理中",
        "resolved": "已解决"
      }
    },
    "voice": {
      "title": "语音助手",
      "listening": "我在听...",
      "thinking": "让我想想...",
      "speaking": "正在说话...",
      "error": "抱歉，我没听清。再试一次？",
      "ready": "您想知道什么？",
      "listeningNow": "正在听...",
      "wakeWordHint": "说 \"Jarvis\" 说话"
    },
    "wizard": {
      "role": "您的向导"
    }
  },
  "jerusalem": {
    "title": "耶路撒冷连接",
    "subtitle": "与以色列的心脏保持联系",
    "noContent": "无可用耶路撒冷内容",
    "sources": "来源",
    "kotelLive": "西墙直播",
    "categories": {
      "kotel": "西墙",
      "idf-ceremony": "以色列国防军仪式",
      "diaspora-connection": "散居联系",
      "holy-sites": "圣地",
      "jerusalem-events": "耶路撒冷活动",
      "general": "耶路撒冷"
    }
  },
  "telAviv": {
    "title": "特拉维夫连接",
    "subtitle": "永不停歇的城市",
    "noContent": "无可用特拉维夫内容",
    "sources": "来源",
    "beachLive": "海滩摄像头",
    "categories": {
      "beaches": "海滩",
      "nightlife": "夜生活",
      "culture": "文化与艺术",
      "music": "音乐现场",
      "food": "美食",
      "tech": "科技与创业",
      "events": "活动",
      "general": "特拉维夫"
    }
  },
  "voiceOnboarding": {
    "welcome": {
      "title": "[zh] Welcome to Voice Control",
      "description": "[zh] Control Bayit+ with your voice for a hands-free experience."
    },
    "features": {
      "voiceCommands": "语音命令",
      "voiceCommandsDesc": "用自然语言导航、搜索和控制播放",
      "tts": "文字转语音",
      "ttsDesc": "聆听响应和内容描述",
      "wakeWord": "唤醒词",
      "wakeWordDesc": "说 'Bayit' 随时激活语音控制"
    },
    "getStarted": "开始使用",
    "permissions": {
      "title": "麦克风权限",
      "description": "语音控制需要麦克风权限来听取您的命令",
      "privacy": "您的语音数据安全处理，不会被存储"
    },
    "permissionsGranted": "麦克风权限已授予",
    "permissionRequired": {
      "title": "需要权限",
      "message": "请在设备设置中启用麦克风权限以使用语音控制"
    },
    "grantPermissions": "授予权限",
    "testWakeWord": {
      "title": "测试唤醒词",
      "description": "说 'Bayit' 测试语音激活",
      "success": "太棒了！语音激活正常工作"
    },
    "startTest": "开始测试",
    "complete": {
      "title": "一切就绪！",
      "description": "语音控制已启用。试试这些命令：",
      "tryCommands": "试试这些命令",
      "examples": {
        "search": "\"搜索 Fauda\"",
        "play": "\"播放新闻\"",
        "navigate": "\"转到直播电视\"",
        "control": "\"暂停\" 或 \"调高音量\""
      },
      "startUsing": "开始使用语音控制"
    },
    "skip": "暂时跳过",
    "buttons": {
      "back": "[zh] Back"
    },
    "completion": {
      "message": "[zh] Voice features are ready to use.",
      "title": "[zh] Voice Setup Complete"
    },
    "title": "[zh] Voice Setup",
    "training": {
      "message": "[zh] Read the phrases aloud to train voice recognition.",
      "title": "[zh] Voice Training"
    }
  },
  "taxonomy": {
    "sections": {
      "movies": "[zh] Movies",
      "series": "[zh] Series",
      "kids": "[zh] Kids",
      "youngsters": "[zh] Youngsters",
      "music": "[zh] Music",
      "documentaries": "[zh] Documentaries",
      "podcasts": "[zh] Podcasts",
      "live": "[zh] Live TV"
    },
    "subcategories": {
      "learning-hebrew": "[zh] Learning Hebrew",
      "young-science": "[zh] Young Science",
      "math-fun": "[zh] Fun Math",
      "nature-animals": "[zh] Nature & Animals",
      "interactive": "[zh] Interactive",
      "hebrew-songs": "[zh] Hebrew Songs",
      "nursery-rhymes": "[zh] Nursery Rhymes",
      "kids-movies": "[zh] Kids Movies",
      "kids-series": "[zh] Kids Series",
      "jewish-holidays": "[zh] Jewish Holidays",
      "torah-stories": "[zh] Torah Stories",
      "bedtime-stories": "[zh] Bedtime Stories",
      "tiktok-trends": "[zh] TikTok Trends",
      "viral-videos": "[zh] Viral Videos",
      "memes": "[zh] Memes",
      "israel-news": "[zh] Israel News",
      "world-news": "[zh] World News",
      "science-news": "[zh] Science News",
      "sports-news": "[zh] Sports News",
      "music-culture": "[zh] Music Culture",
      "film-culture": "[zh] Film Culture",
      "art-culture": "[zh] Art Culture",
      "food-culture": "[zh] Food Culture",
      "study-help": "[zh] Study Help",
      "career-prep": "[zh] Career Prep",
      "life-skills": "[zh] Life Skills",
      "teen-movies": "[zh] Teen Movies",
      "teen-series": "[zh] Teen Series",
      "gaming": "[zh] Gaming",
      "coding": "[zh] Coding",
      "gadgets": "[zh] Gadgets",
      "bar-bat-mitzvah": "[zh] Bar/Bat Mitzvah",
      "teen-torah": "[zh] Teen Torah",
      "jewish-history": "[zh] Jewish History",
      "learning-hebrew.description": "儿童希伯来语阅读、书写和词汇学习",
      "young-science.description": "适合儿童的实验和科学讲解",
      "math-fun.description": "以有趣和游戏的方式学习数字和算术",
      "nature-animals.description": "好奇儿童的动物和自然世界",
      "interactive.description": "儿童互动参与内容",
      "hebrew-songs.description": "经典和新的以色列儿童歌曲",
      "nursery-rhymes.description": "幼儿和婴儿的歌曲和旋律",
      "kids-movies.description": "适合儿童的完整电影",
      "kids-series.description": "儿童动画系列和电视节目",
      "jewish-holidays.description": "儿童犹太节日和传统内容",
      "torah-stories.description": "托拉和犹太传统的故事",
      "bedtime-stories.description": "睡前放松故事",
      "tiktok-trends.description": "TikTok上的热门趋势和挑战",
      "viral-videos.description": "社交媒体上的热门病毒视频",
      "memes.description": "有趣的表情包和网络文化",
      "israel-news.description": "适合青少年的以色列新闻",
      "world-news.description": "青少年国际新闻",
      "science-news.description": "科学发现和技术创新",
      "sports-news.description": "体育动态和比赛结果",
      "music-culture.description": "音乐界、艺术家和音乐节",
      "film-culture.description": "电影、剧集和评论",
      "art-culture.description": "艺术、画廊和创意",
      "food-culture.description": "烹饪、食谱和饮食文化",
      "study-help.description": "考试辅导、总结和备考帮助",
      "career-prep.description": "大学和职业准备",
      "life-skills.description": "生活技能、财务管理和独立能力",
      "teen-movies.description": "推荐给青少年的电影",
      "teen-series.description": "青少年热门剧集",
      "gaming.description": "电子游戏、电竞和游戏",
      "coding.description": "编程、代码和软件开发",
      "gadgets.description": "数码产品、科技和评测",
      "bar-bat-mitzvah.description": "成人礼的准备和庆祝",
      "teen-torah.description": "青少年托拉课程和每周读经",
      "jewish-history.description": "犹太民族的历史"
    }
  },
  "passkey": {
    "manager": {
      "title": "[zh] Passkeys",
      "subtitle": "[zh] Manage your passkeys for secure content access"
    },
    "unsupported": "[zh] Passkeys are not supported on this device",
    "fetchError": "[zh] Failed to load passkeys",
    "registerError": "[zh] Failed to register passkey",
    "deleteError": "[zh] Failed to delete passkey",
    "cancelled": "[zh] Passkey operation was cancelled",
    "noPasskeys": "[zh] No passkeys registered yet. Add one to unlock private content.",
    "unknownDevice": "[zh] Unknown Device",
    "created": "[zh] Created",
    "lastUsed": "[zh] Last used",
    "never": "[zh] Never",
    "addPasskey": "[zh] Add Passkey",
    "deleteConfirmTitle": "[zh] Delete Passkey?",
    "deleteConfirmText": "[zh] This passkey will no longer be able to unlock content. You can always add it again later.",
    "unlock": "[zh] Unlock",
    "unlockContent": "[zh] Unlock Private Content",
    "unlockDescription": "[zh] Use your passkey to access private movies and series",
    "auth": {
      "title": "[zh] Unlock Content",
      "description": "[zh] Use your fingerprint, face, or device PIN to unlock private movies and series.",
      "unlock": "[zh] Unlock with Passkey",
      "authenticating": "[zh] Authenticating...",
      "success": "[zh] Content Unlocked!",
      "cancelled": "[zh] Authentication was cancelled",
      "error": "[zh] Authentication failed. Please try again."
    },
    "qr": {
      "useQR": "[zh] Use Phone to Unlock",
      "scanWithPhone": "[zh] Scan with your phone",
      "instruction": "[zh] Open the camera on your phone and scan the QR code to authenticate",
      "error": "[zh] Failed to generate QR code",
      "expired": "[zh] QR code expired. Please try again."
    }
  },
  "olorin": {
    "errors": {
      "session_not_found": "[zh] Session not found",
      "session_different_partner": "[zh] Session belongs to different partner",
      "session_invalid_status": "[zh] Session is {status}, cannot add transcript",
      "max_sessions_reached": "[zh] Maximum concurrent sessions ({limit}) reached",
      "invalid_api_key": "[zh] Invalid API key",
      "missing_api_key": "[zh] Missing {header} header",
      "capability_disabled": "[zh] Capability '{capability}' is currently disabled",
      "capability_not_enabled": "[zh] Capability '{capability}' not enabled for this partner",
      "source_language_not_supported": "[zh] Source language '{language}' not supported. Supported: {supported}",
      "target_language_not_supported": "[zh] Target language '{language}' not supported. Supported: {supported}",
      "partner_not_found": "[zh] Partner not found",
      "partner_registration_failed": "[zh] Failed to register partner",
      "no_updates_provided": "[zh] No updates provided",
      "webhook_config_failed": "[zh] Failed to configure webhook",
      "webhook_url_not_configured": "[zh] Webhook URL not configured",
      "webhook_secret_not_configured": "[zh] Webhook secret not configured",
      "search_failed": "[zh] Search failed",
      "indexing_failed": "[zh] Indexing failed",
      "detection_failed": "[zh] Detection failed",
      "explanation_failed": "[zh] Failed to get explanation",
      "reference_not_found": "[zh] Reference '{reference_id}' not found",
      "enrichment_failed": "[zh] Enrichment failed",
      "get_references_failed": "[zh] Failed to get references",
      "create_session_failed": "[zh] Failed to create session",
      "add_transcript_failed": "[zh] Failed to add transcript",
      "generate_recap_failed": "[zh] Failed to generate recap"
    }
  },
  "portal": {
    "nav": {
      "home": "首页",
      "features": "功能",
      "solutions": "解决方案",
      "pricing": "定价",
      "demo": "实时演示",
      "contact": "联系我们",
      "getStarted": "开始使用"
    },
    "hero": {
      "ctaExplore": "探索功能",
      "ctaDemo": "请求演示"
    },
    "cta": {
      "title": "准备好开始了吗？",
      "subtitle": "让我们讨论如何帮助改变您的业务",
      "button": "联系我们"
    },
    "contactPage": {
      "title": "联系我们",
      "subtitle": "对我们的解决方案感兴趣？让我们交谈",
      "formTitle": "给我们发消息",
      "infoTitle": "联系信息",
      "form": {
        "name": "全名",
        "email": "电子邮件地址",
        "company": "公司名称",
        "phone": "电话号码",
        "message": "您的消息",
        "messagePlaceholder": "告诉我们您的需求..."
      },
      "submit": "发送消息",
      "sending": "发送中...",
      "success": "消息已成功发送！我们很快会与您联系。",
      "error": "发送消息失败。请重试。",
      "scheduleTitle": "更喜欢安排通话？",
      "scheduleSubtitle": "与我们的团队预订个性化演示",
      "scheduleCta": "安排演示通话"
    },
    "pricingPage": {
      "title": "实惠的",
      "titleHighlight": "定价计划",
      "subtitle": "选择适合您需求的计划",
      "comparisonTitle": "功能比较",
      "faqTitle": "常见问题",
      "faq": {
        "q1": "定价如何计算？",
        "a1": "定价基于您的具体需求和使用情况。联系我们获取定制报价。",
        "q2": "我以后可以升级我的计划吗？",
        "a2": "是的，您可以随时升级。我们将帮助您无缝迁移数据。",
        "q3": "包含什么支持？",
        "a3": "所有计划都包括电子邮件支持。专业版和企业版计划包括专属客户经理的优先支持。"
      },
      "professional": {
        "name": "专业版",
        "price": "联系获取报价",
        "priceNote": "定制定价",
        "description": "适用于有高级需求的成长型企业",
        "cta": "获取报价"
      },
      "enterprise": {
        "name": "企业版",
        "price": "定制",
        "priceNote": "基于使用量",
        "description": "适用于大型组织和企业部署",
        "cta": "联系销售"
      },
      "ctaTitle": "准备好开始了吗？",
      "ctaSubtitle": "让我们讨论您的需求并找到完美的计划",
      "ctaButton": "联系销售"
    },
    "featuresPage": {
      "title": "强大的",
      "titleHighlight": "功能",
      "subtitle": "成功所需的一切",
      "techSpecsTitle": "技术规格",
      "workflowTitle": "工作原理",
      "workflow": {
        "s1": {
          "title": "导入",
          "description": "上传和组织您的内容"
        },
        "s2": {
          "title": "配置",
          "description": "设置您的偏好和设置"
        },
        "s3": {
          "title": "部署",
          "description": "启动您的解决方案"
        },
        "s4": {
          "title": "监控",
          "description": "跟踪性能并优化"
        }
      },
      "ctaTitle": "准备好探索功能了吗？",
      "ctaSubtitle": "通过个性化演示查看所有功能的实际应用",
      "ctaButton": "安排演示"
    },
    "demoPage": {
      "title": "查看我们的",
      "titleHighlight": "平台",
      "subtitle": "体验我们解决方案的强大功能",
      "scheduleCta": "安排实时演示",
      "stepsTitle": "工作原理",
      "steps": {
        "analyze": {
          "title": "分析",
          "description": "跟踪和改进性能"
        }
      },
      "featuresTitle": "平台亮点",
      "platformsTitle": "可用平台",
      "ctaTitle": "准备好您的定制演示了吗？",
      "ctaSubtitle": "安排根据您的需求定制的个性化演示",
      "ctaButton": "安排演示"
    },
    "workflow": {
      "sectionTitle": "智能工作流",
      "sectionSubtitle": "4步精简流程",
      "step1": {
        "title": "设置",
        "description": "配置您的帐户和偏好"
      },
      "step2": {
        "title": "自定义",
        "description": "根据您的需求自定义设置"
      },
      "step3": {
        "title": "部署",
        "description": "启动您的解决方案"
      },
      "step4": {
        "title": "监控",
        "description": "跟踪性能并优化"
      }
    }
  },
  "trivia": {
    "didYouKnow": "你知道吗？",
    "dismissHint": "关闭小知识",
    "settings": {
      "displayLanguages": "显示语言",
      "languageHint": "选择1-3种语言显示每个事实",
      "language": "语言",
      "selectLanguage": "选择此语言",
      "deselectLanguage": "取消选择此语言",
      "enableDescription": "[zh] Show trivia questions while watching content.",
      "enableTrivia": "[zh] Enable Trivia",
      "title": "[zh] Trivia Settings"
    },
    "aiTrivia": "AI 问答",
    "tellMeMore": "告诉我更多",
    "more": "更多",
    "follow_up": "跟进"
  },
  "auth": {
    "loginRequired": "[zh] Login Required",
    "loginToWatch": "[zh] Please sign in to watch {{title}}",
    "login": "[zh] Login",
    "signUp": "[zh] Sign Up",
    "biometricEnrollEnable": "[zh] Enable",
    "biometricEnrollMessage": "[zh] Use Face ID or fingerprint for faster sign-in next time.",
    "biometricEnrollSkip": "[zh] Skip",
    "biometricEnrollTitle": "[zh] Enable Biometric Sign-In",
    "biometricSignIn": "[zh] Sign in with Biometrics",
    "signOut": "[zh] Sign Out",
    "register": {
      "createAccount": "创建账户",
      "email": "邮箱",
      "password": "密码",
      "confirmPassword": "确认密码",
      "register": "注册",
      "alreadyHaveAccount": "已有账户？登录",
      "passwordStrength": {
        "weak": "弱",
        "medium": "中等",
        "strong": "强"
      }
    }
  },
  "recording": {
    "stop": "停止录制",
    "start": "开始录制"
  },
  "discover": {
    "title": "[zh] Discover",
    "subtitle": "探索19项AI驱动功能",
    "description": "Bayit+利用AI提升您的观看、收听和学习体验。探索您平台上可用的功能。",
    "featureCount": "{{count}} 项功能",
    "tryIt": "立即体验",
    "startWalkthrough": "开始导览",
    "availableOn": "适用于",
    "prerequisites": "前提条件",
    "setup": "设置",
    "error": {
      "fetchFailed": "加载Discover功能失败，请重试。",
      "unknownFeature": "未找到该功能。",
      "featureDisabled": "此功能当前已禁用。"
    },
    "availability": {
      "ready": "就绪",
      "setupNeeded": "需要设置",
      "premiumRequired": "需要高级订阅",
      "notAvailable": "不可用",
      "platformOnly": "其他平台"
    },
    "platform": {
      "web": "Web",
      "ios": "iOS",
      "android": "Android",
      "tvos": "Apple TV"
    },
    "category": {
      "watching_movies": "观看电影",
      "watching_live_tv": "观看直播电视",
      "learn_hebrew": "学习希伯来语",
      "search_discovery": "搜索与发现",
      "chat_assistants": "聊天助手"
    },
    "feature": {
      "pause_ask": {
        "name": "暂停提问",
        "tagline": "暂停任意场景，向您的AI伙伴提问",
        "description": "观看时，暂停视频并对当前场景提问。您的AI角色将解释文化背景、翻译对话或讨论剧情。"
      },
      "interactive_subtitles": {
        "name": "互动字幕",
        "tagline": "点击任意字幕词汇，即时获取翻译和背景信息",
        "description": "点击字幕中的任意单词，查看翻译、听取发音并获取使用示例。在观看您喜爱的节目时积累词汇。"
      },
      "vocabulary": {
        "name": "词汇构建器",
        "tagline": "从您观看的节目中学习新词汇",
        "description": "自动从字幕中收集新的希伯来语词汇。复习闪卡、追踪进度，通过您喜爱的内容构建词汇量。"
      },
      "vod_moments": {
        "name": "VOD精彩时刻",
        "tagline": "AI精选您最喜爱内容的精彩片段",
        "description": "获取AI生成的电影和节目精彩片段与关键时刻。分享难忘场景，重温最精彩的部分。"
      },
      "cultural_context": {
        "name": "文化背景",
        "tagline": "了解每个场景背后的文化背景",
        "description": "获取实时文化注释，解释您所观看内容中出现的以色列风俗、节日、幽默和社会规范。"
      },
      "bilingual_bridge": {
        "name": "双语桥梁",
        "tagline": "观看时同步进行希伯来语-中文学习",
        "description": "查看带有重点词汇的双语字幕。在希伯来语和母语之间切换，自然地提升理解能力。"
      },
      "ai_companion": {
        "name": "AI陪伴",
        "tagline": "您了解以色列内容的AI私人向导",
        "description": "AI角色与您一同观看，提供评论、回答问题，帮助您理解以色列媒体的细微差异。"
      },
      "live_dubbing": {
        "name": "实时配音",
        "tagline": "以色列直播频道的实时AI配音",
        "description": "以您偏好的语言观看带有AI实时配音的以色列直播电视。无语言障碍地享受新闻、脱口秀和娱乐节目。"
      },
      "live_subtitles": {
        "name": "直播字幕",
        "tagline": "直播节目的实时AI字幕",
        "description": "观看以色列直播电视时实时获取AI生成的字幕。选择您偏好的语言即时翻译直播内容。"
      },
      "live_trivia": {
        "name": "直播问答",
        "tagline": "根据直播内容进行趣味问答游戏",
        "description": "AI检测直播节目的话题并实时生成问答题。与朋友竞争，在看电视的同时了解以色列文化。"
      },
      "catch_up": {
        "name": "快速补看",
        "tagline": "AI总结您错过的直播内容",
        "description": "错过了部分直播？获取AI生成的摘要，快速了解发生了什么，关键时刻已标注，方便快速回顾。"
      },
      "scene_search": {
        "name": "场景搜索",
        "tagline": "在所有内容中搜索特定场景",
        "description": "描述您记得的场景，AI将在所有可用内容中找到它。通过对话、视觉元素或情节描述进行搜索。"
      },
      "phonetic_mirror": {
        "name": "语音镜像",
        "tagline": "通过AI反馈练习希伯来语发音",
        "description": "录制自己说希伯来语并获得AI关于发音的即时反馈。与母语者的语音进行比较，随时间追踪进步。"
      },
      "talk_back": {
        "name": "对话练习",
        "tagline": "用希伯来语与您的AI角色进行语音对话",
        "description": "通过与AI角色交谈练习希伯来语会话。在自然对话中获得语法、词汇和发音的实时反馈。"
      },
      "interactive_mission": {
        "name": "互动任务",
        "tagline": "在AI引导下完成有趣的希伯来语学习挑战",
        "description": "完成AI引导的任务，将观看内容与希伯来语学习练习相结合。赚取奖励并追踪您的语言学习历程。"
      },
      "glossary": {
        "name": "个人词汇表",
        "tagline": "从内容中构建的您的个性化希伯来语词典",
        "description": "您所遇到并保存的所有希伯来语词汇，按类别、频率和掌握程度整理。随时复习和练习。"
      },
      "llm_search": {
        "name": "AI搜索",
        "tagline": "用自然语言查询查找内容",
        "description": "使用自然语言搜索整个Bayit+库。询问「关于家庭的有趣以色列喜剧」或「特拉维夫纪录片」，获取AI精选结果。"
      },
      "proactive_voice": {
        "name": "主动语音",
        "tagline": "预判您需求的语音优先AI助手",
        "description": "AI助手主动倾听并根据您正在观看的内容，提供相关内容建议、翻译和学习机会。"
      },
      "chatbot": {
        "name": "Bayit聊天",
        "tagline": "与AI就以色列内容相关的任何话题聊天",
        "description": "询问有关以色列文化的问题、获取内容推荐、练习希伯来语或讨论您观看的内容。您的AI伙伴随时待命。"
      }
    },
    "prereq": {
      "avatar": "创建您的AI角色",
      "subscription": "需要高级订阅",
      "microphone": "需要麦克风权限",
      "contentType": "选择您的内容偏好",
      "preference": "设置您的语言偏好",
      "voiceClone": "设置您的声音克隆"
    },
    "walkthrough": {
      "tryItNow": "[zh] Try it now",
      "watchDemo": "[zh] Watch demo",
      "skip": "[zh] Skip",
      "next": "[zh] Next",
      "done": "[zh] Done",
      "complete": "[zh] Walkthrough complete",
      "stepCounter": "[zh] {{current}} of {{total}}",
      "pause_ask": {
        "step1": "[zh] Navigate to a movie with interactive moments",
        "step2": "[zh] Pause the movie during a scene",
        "step3": "[zh] Tap the Ask a Character button",
        "step4": "[zh] Watch the character respond to you"
      },
      "interactive_subtitles": {
        "step1": "[zh] Start playing a movie with subtitles",
        "step2": "[zh] Tap the Interactive button in the control bar",
        "step3": "[zh] Select your subtitle language",
        "step4": "[zh] Tap any word in the subtitles to learn more"
      },
      "vocabulary": {
        "step1": "[zh] Open a movie with interactive subtitles enabled",
        "step2": "[zh] Tap a word you want to learn",
        "step3": "[zh] Tap Save to Vocabulary",
        "step4": "[zh] Review your saved words in the Vocabulary section"
      },
      "vod_moments": {
        "step1": "[zh] Start watching a movie with interactive moments",
        "step2": "[zh] Wait for an interactive prompt to appear",
        "step3": "[zh] See the AI-generated interaction"
      },
      "cultural_context": {
        "step1": "[zh] Play a movie with Hebrew dialogue",
        "step2": "[zh] Tap on a subtitle with cultural significance",
        "step3": "[zh] Read the AI-generated cultural explanation"
      },
      "bilingual_bridge": {
        "step1": "[zh] Open a movie with bilingual support",
        "step2": "[zh] Select the bilingual subtitle mode",
        "step3": "[zh] Tap a highlighted phrase to see the translation",
        "step4": "[zh] Watch both languages side by side"
      },
      "ai_companion": {
        "step1": "[zh] Start watching any movie",
        "step2": "[zh] Tap the AI Companion button",
        "step3": "[zh] Type a question about the movie",
        "step4": "[zh] Read the contextual AI response"
      },
      "live_dubbing": {
        "step1": "[zh] Navigate to a live TV channel",
        "step2": "[zh] Tap the dubbing button in the control bar",
        "step3": "[zh] Select your preferred language",
        "step4": "[zh] Listen to the real-time AI dubbing"
      },
      "live_subtitles": {
        "step1": "[zh] Navigate to a live TV channel",
        "step2": "[zh] Tap the subtitles button",
        "step3": "[zh] Select your subtitle language",
        "step4": "[zh] Watch the real-time subtitles appear"
      },
      "live_trivia": {
        "step1": "[zh] Navigate to a live TV channel",
        "step2": "[zh] Tap the trivia button",
        "step3": "[zh] Answer the AI-generated questions"
      },
      "catch_up": {
        "step1": "[zh] Navigate to a live broadcast",
        "step2": "[zh] Select the catch-up option",
        "step3": "[zh] Tap to generate an AI summary",
        "step4": "[zh] Read the summary of what you missed"
      },
      "scene_search": {
        "step1": "[zh] Navigate to a recorded broadcast",
        "step2": "[zh] Type what you are looking for",
        "step3": "[zh] Tap on the matching scene",
        "step4": "[zh] Watch the scene from that point"
      },
      "phonetic_mirror": {
        "step1": "[zh] Open the Phonetic Mirror in Zeh Ani",
        "step2": "[zh] Read the Hebrew phrase shown",
        "step3": "[zh] Speak the phrase into your microphone",
        "step4": "[zh] Review the AI pronunciation feedback"
      },
      "talk_back": {
        "step1": "[zh] Open Talk Back in Zeh Ani",
        "step2": "[zh] Listen to your avatar speak Hebrew",
        "step3": "[zh] Respond in Hebrew using your microphone",
        "step4": "[zh] Review the AI feedback on your response"
      },
      "interactive_mission": {
        "step1": "[zh] Open Interactive Missions",
        "step2": "[zh] Select a mission level",
        "step3": "[zh] Follow the AI-guided exercises",
        "step4": "[zh] Complete the mission and earn rewards"
      },
      "glossary": {
        "step1": "[zh] Open the Hebrew Glossary",
        "step2": "[zh] Search for a Hebrew word",
        "step3": "[zh] Listen to the pronunciation"
      },
      "llm_search": {
        "step1": "[zh] Open the Search tab",
        "step2": "[zh] Type a natural language query",
        "step3": "[zh] Browse the AI-curated results"
      },
      "proactive_voice": {
        "step1": "[zh] Open the Voice Suggestions feature",
        "step2": "[zh] Tap and hold to speak",
        "step3": "[zh] Hear the personalized recommendations"
      },
      "chatbot": {
        "step1": "[zh] Open the AI Assistant",
        "step2": "[zh] Type your question or request",
        "step3": "[zh] Read the AI response"
      }
    }
  },
  "byoc": {
    "home": {
      "title": "[zh] Bring Your Own Content",
      "subtitle": "[zh] Connect your IPTV, Plex, or YouTube sources and enjoy Bayit+ AI features on your own content",
      "connectButton": "[zh] Connect Sources",
      "aiFeatures": {
        "dubbing": "[zh] AI Dubbing available",
        "subtitles": "[zh] Live Subtitles available"
      }
    },
    "pageSubtitle": "带来您自己的内容 - 添加 IPTV 和流媒体来源",
    "addSource": "添加来源",
    "sync": "同步",
    "remove": "移除",
    "channelCount": "{{count}} 个频道",
    "empty": {
      "title": "未添加任何来源",
      "subtitle": "添加您的 IPTV、Xtream 或流媒体来源，在 Bayit+ 旁边观看您自己的内容"
    },
    "source": {
      "iptv": "IPTV 来源",
      "xtream": "Xtream Codes"
    },
    "sourceType": {
      "iptv": "IPTV / M3U",
      "xtream": "Xtream Codes"
    },
    "addIptv": {
      "title": "添加 IPTV 来源",
      "subtitle": "输入 M3U 或 M3U8 播放列表文件的 URL",
      "urlPlaceholder": "https://example.com/playlist.m3u",
      "validate": "验证",
      "add": "添加来源"
    },
    "addXtream": {
      "title": "连接 Xtream Codes",
      "subtitle": "输入您的 Xtream Codes 服务器凭据",
      "serverUrl": "服务器 URL",
      "username": "用户名",
      "password": "密码",
      "connect": "连接"
    },
    "preview": {
      "title": "预览",
      "channelCount": "找到 {{count}} 个频道"
    },
    "providers": {
      "title": "热门提供商"
    },
    "wizard": {
      "step1": "添加来源",
      "step2": "处理中",
      "step3": "审核",
      "selectSource": "选择来源类型"
    },
    "normalization": {
      "title": "正在处理您的内容",
      "total": "共 {{count}} 个频道",
      "matched": "已匹配 {{count}} 个",
      "stage": {
        "parsing": "正在解析播放列表...",
        "matching": "正在匹配频道...",
        "enriching": "正在丰富元数据...",
        "finalizing": "正在完成..."
      }
    },
    "review": {
      "title": "审核已导入的内容",
      "subtitle": "已匹配 {{matched}} 个，{{unmatched}} 个频道未匹配",
      "matchedChannels": "已匹配频道",
      "unmatchedChannels": "未匹配频道",
      "apply": "应用并导入"
    },
    "error": {
      "urlRequired": "请输入 URL",
      "noChannels": "此播放列表中未找到频道",
      "invalidUrl": "无法从此 URL 加载播放列表",
      "allFieldsRequired": "所有字段均为必填项",
      "enrichFailed": "分析来源失败",
      "syncFailed": "同步来源失败",
      "normalizationFailed": "内容处理失败",
      "normalizationPollFailed": "处理过程中连接中断"
    },
    "plex": {
      "connectPlex": "连接Plex",
      "enterCodeAt": "请在以下网址输入此代码",
      "waitingForAuth": "等待授权中...",
      "selectServer": "选择Plex服务器",
      "connecting": "正在连接{{serverName}}...",
      "connected": "已连接",
      "label": "Plex"
    },
    "settings": {
      "title": "您的内容来源",
      "refresh": "刷新",
      "noSources": "未连接任何内容来源",
      "noSourcesSubtitle": "连接您的Plex、YouTube、IPTV或Xtream提供商",
      "removeSource": "移除来源",
      "plexSubtitle": "从您的Plex媒体服务器串流",
      "youtubeSubtitle": "访问您的YouTube媒体库",
      "iptvXtreamLabel": "IPTV / Xtream",
      "iptvXtreamSubtitle": "添加M3U播放列表或Xtream代码",
      "youtube": "YouTube",
      "xtreamCodes": "Xtream Codes",
      "iptv": "IPTV"
    }
  },
  "onboarding": {
    "welcome": {
      "title": "欢迎使用 Bayit+",
      "subtitle": "您的 AI 驱动的以色列内容、文化和语言学习门户",
      "getStarted": "开始"
    },
    "highlight": {
      "dubbing": "AI 实时配音",
      "subtitles": "互动字幕",
      "ai": "AI 伙伴",
      "learning": "希伯来语学习"
    },
    "voice": {
      "title": "语音设置",
      "subtitle": "启用麦克风以使用语音命令、希伯来语发音练习和免提导航",
      "enable": "启用麦克风",
      "granted": "麦克风已成功启用"
    },
    "tour": {
      "done": "完成"
    },
    "demo": {
      "dubbing": {
        "title": "AI 实时配音",
        "description": "用您喜欢的语言实时 AI 配音观看以色列电视",
        "hebrew": "希伯来语",
        "english": "英语"
      },
      "subtitles": {
        "title": "互动字幕",
        "description": "点击字幕中的任意单词即可获得即时翻译和发音",
        "sample": "一家人聚在一起吃 Shabbat 晚餐",
        "word": "安息日",
        "translation": "安息日 - 每周休息日"
      },
      "interaction": {
        "title": "AI 角色互动",
        "description": "暂停任意场景，向您的 AI 伙伴询问文化背景",
        "userMsg": "他们在庆祝什么节日？",
        "aiMsg": "他们在庆祝 Sukkot，即住棚节。您看到的临时小屋叫做 sukkah。"
      },
      "trivia": {
        "title": "实时问答",
        "description": "AI 根据正在直播的内容生成问答题。竞赛并学习！",
        "question": "以色列的官方语言是什么？",
        "optionA": "阿拉伯语",
        "optionB": "希伯来语",
        "optionC": "英语"
      },
      "catchup": {
        "title": "智能补播",
        "description": "错过了部分直播？AI 为您总结错过的内容",
        "missed": "已错过",
        "summary": "AI 摘要",
        "live": "正在直播"
      },
      "byoc": {
        "title": "带来您自己的内容",
        "description": "导入您的 IPTV 源，与 Bayit+ 内容一起观看",
        "step1": "添加来源",
        "step2": "AI 增强",
        "step3": "观看"
      },
      "zehAni": {
        "title": "创建您的 AI 角色",
        "description": "生成与您一同学习的个性化 AI 头像",
        "generated": "AI 头像"
      }
    }
  },
  "dm": {
    "title": "消息",
    "conversations": "对话",
    "conversation": "对话",
    "empty": {
      "title": "暂无消息",
      "subtitle": "与朋友开始一段对话"
    },
    "input": {
      "placeholder": "输入消息...",
      "send": "发送"
    },
    "translate": "翻译",
    "react": "表情回应",
    "read": "已读",
    "sent": "已发送",
    "loadMore": "加载更早的消息",
    "startConversation": "发送消息以开始对话",
    "reaction": {
      "like": "点赞",
      "love": "喜爱",
      "laugh": "哈哈",
      "surprise": "哇",
      "sad": "悲伤"
    },
    "error": {
      "fetchFailed": "加载消息失败",
      "sendFailed": "发送消息失败"
    }
  },
  "household": {
    "empty": {
      "title": "尚未创建家庭",
      "subtitle": "创建家庭以管理您的家人"
    },
    "create": {
      "namePlaceholder": "家庭名称",
      "button": "创建家庭"
    },
    "members": "成员",
    "role": {
      "owner": "所有者",
      "guardian": "监护人",
      "child": "孩子"
    },
    "invite": {
      "title": "邀请成员",
      "emailPlaceholder": "电子邮件地址",
      "send": "发送邀请",
      "pending": "待处理的邀请"
    },
    "removeMember": "移除",
    "error": {
      "fetchFailed": "加载家庭失败",
      "createFailed": "创建家庭失败",
      "updateFailed": "更新家庭失败",
      "deleteFailed": "删除家庭失败",
      "inviteFailed": "发送邀请失败",
      "removeFailed": "移除成员失败"
    }
  },
  "aiChat": {
    "retryButton": "[zh] Retry",
    "sendButton": "[zh] Send",
    "title": "[zh] AI Chat",
    "voiceButton": "[zh] Voice"
  },
  "aiOnboarding": {
    "buttons": {
      "back": "[zh] Back"
    },
    "completion": {
      "message": "[zh] You're all set! Start exploring AI features.",
      "title": "[zh] Setup Complete"
    },
    "permissions": {
      "description": "[zh] Grant permissions to enable AI features like voice and camera.",
      "title": "[zh] Permissions"
    },
    "personalization": {
      "description": "[zh] Tell us your preferences to personalize your AI experience.",
      "title": "[zh] Personalization"
    },
    "title": "[zh] AI Setup",
    "welcome": {
      "description": "[zh] Bayit+ uses AI to enhance your viewing experience with dubbing, subtitles, and more.",
      "title": "[zh] Welcome to Bayit+ AI"
    }
  },
  "auth_device_authorized": "[zh] Device authorized",
  "auth_device_code_expired": "[zh] Code expired",
  "auth_device_get_new_code": "[zh] Get new code",
  "auth_device_manual_login": "[zh] Sign in manually",
  "auth_device_visit_uri": "[zh] Visit the URL shown on your TV",
  "avatar": {
    "tapToSpeak": "[zh] Tap to speak",
    "title": "[zh] Avatar"
  },
  "dubbing": {
    "mixer": {
      "dubbedAudio": "[zh] Dubbed Audio",
      "originalAudio": "[zh] Original Audio",
      "title": "[zh] Audio Mixer"
    },
    "settings_title": "[zh] Dubbing Settings",
    "target_language": "[zh] Target Language",
    "voiceSelector": {
      "selected": "[zh] Selected",
      "subtitle": "[zh] Choose a voice for dubbing",
      "title": "[zh] Voice Selection"
    }
  },
  "go_back": "[zh] Go Back",
  "miniPlayer": {
    "closePlayer": "[zh] Close Player",
    "skipBackward": "[zh] Skip Backward",
    "skipForward": "[zh] Skip Forward"
  },
  "retry": "[zh] Retry",
  "search_hint": "[zh] Search channels, movies, shows...",
  "search_no_results": "[zh] No results found",
  "search_prompt": "[zh] What are you looking for?",
  "subscription_required": "[zh] Subscription Required",
  "subscription_upsell_tv": "[zh] Upgrade to watch on TV",
  "talkback": {
    "title": "[zh] Talkback"
  },
  "voiceAssistant": {
    "fabLabel": "[zh] Voice Assistant",
    "modal": {
      "cancel": "[zh] Cancel",
      "setupMessage": "[zh] Set up voice recognition to use the voice assistant.",
      "setupRequired": "[zh] Setup Required",
      "startSetup": "[zh] Start Setup",
      "title": "[zh] Voice Assistant"
    }
  },
  "voiceCommand": {
    "executing": "[zh] Executing...",
    "listening": "[zh] Listening...",
    "noMatch": "[zh] No match found",
    "recognized": "[zh] Recognized"
  },
  "voiceDecision": {
    "cancel": "[zh] Cancel",
    "confirm": "[zh] Confirm",
    "matched": "[zh] Matched"
  },
  "voiceSearch": {
    "listening": "[zh] Listening...",
    "noResults": "[zh] No results found",
    "tapToSpeak": "[zh] Tap to speak",
    "title": "[zh] Voice Search"
  },
  "voiceSettings": {
    "language": "[zh] Language",
    "speechRate": "[zh] Speech Rate",
    "title": "[zh] Voice Settings",
    "ttsProvider": "[zh] TTS Provider",
    "voiceMode": "[zh] Voice Mode",
    "voiceSelection": "[zh] Voice Selection",
    "wakeWord": "[zh] Wake Word"
  },
  "voiceWizard": {
    "buttons": {
      "back": "[zh] Back"
    },
    "calibration": {
      "description": "[zh] Speak normally to calibrate the microphone.",
      "listening": "[zh] Listening...",
      "micButton": "[zh] Start Recording",
      "resultTitle": "[zh] Calibration Result",
      "stopButton": "[zh] Stop Recording",
      "tapToStart": "[zh] Tap to start calibration",
      "title": "[zh] Microphone Calibration"
    },
    "complete": {
      "message": "[zh] Voice wizard setup is complete. You can now use voice features.",
      "title": "[zh] Setup Complete"
    },
    "language": {
      "description": "[zh] Select your preferred language for voice commands.",
      "title": "[zh] Voice Language"
    },
    "permission": {
      "description": "[zh] Microphone access is needed for voice features.",
      "granted": "[zh] Permission Granted",
      "requestButton": "[zh] Grant Permission",
      "title": "[zh] Microphone Permission"
    },
    "title": "[zh] Voice Wizard"
  },
  "watch_now": "[zh] Watch Now",
  "culture": {
    "title": "以色列文化",
    "description": "耶路撒冷、特拉维夫和以色列遗产",
    "shabbat": {
      "title": "安息日模式",
      "enableShabbatMode": "启用安息日模式",
      "shabbatTimes": "安息日时间",
      "timesDescription": "蜡烛点燃和哈夫达拉时间将在此显示",
      "aboutTitle": "关于安息日模式",
      "aboutDescription": "启用后，安息日模式将在安息日时间内暂停通知、降低屏幕亮度并启用简化界面。"
    },
    "judaism": {
      "holidaysAndTorah": "节日与托拉",
      "parashaOfTheWeek": "本周读经",
      "parashaDescription": "每周托拉诵读和注释"
    },
    "morning": {
      "title": "晨间仪式",
      "description": "以意愿和感恩开始新的一天",
      "dailyInspiration": "每日灵感",
      "dailyInspirationDescription": "为您的早晨日程精选的内容",
      "modehAni": "莫代阿尼",
      "modehAniDescription": "晨间感恩祈祷",
      "netilatYadayim": "涅提拉特·亚达伊姆",
      "netilatYadayimDescription": "仪式性洗手",
      "shacharit": "沙哈里特",
      "shacharitDescription": "晨间祈祷仪式"
    },
    "glossary": {
      "termDetail": "术语详情",
      "definition": "定义",
      "pronunciation": "发音",
      "examples": "示例"
    },
    "jerusalem": {
      "title": "耶路撒冷"
    },
    "telaviv": {
      "title": "特拉维夫"
    }
  },
  "zehAni": {
    "dashboard": {
      "title": "泽·阿尼",
      "biometricConsent": "生物识别同意",
      "activeConsents": "{{count}} 个有效同意",
      "magicMirror": "魔镜",
      "magicMirrorDescription": "每日问候和面部识别",
      "v2vPractice": "V2V 练习",
      "v2vPracticeDescription": "语音对语音发音",
      "avatar3d": "3D 虚拟形象",
      "avatar3dDescription": "您的个性化虚拟形象网格",
      "movieInteractions": "电影互动",
      "movieInteractionsDescription": "浏览并与电影角色对话",
      "contacts": "联系人",
      "contactsDescription": "WhatsApp 分享联系人",
      "feedback": "反馈",
      "feedbackDescription": "分享您的体验",
      "consent": "同意",
      "consentDescription": "生物识别同意管理",
      "chess": "国际象棋",
      "chessDescription": "与朋友和家人下棋"
    },
    "mirror": {
      "title": "魔镜",
      "avatarContentDescription": "虚拟形象",
      "wordOfTheDay": "每日一词",
      "playLipsync": "播放唇形同步",
      "noAvatarYet": "尚无虚拟形象",
      "noAvatarDescription": "创建 3D 虚拟形象，在故事中看到自己",
      "createAvatar": "创建虚拟形象"
    },
    "mode": {
      "title": "虚拟形象模式",
      "enableAvatarMode": "启用虚拟形象模式",
      "enableDescription": "显示您的虚拟形象对内容的反应",
      "avatarPreview": "虚拟形象预览",
      "avatarPreviewContentDescription": "虚拟形象预览",
      "noAvatarConfigured": "未配置虚拟形象",
      "reactionStyle": "反应风格"
    },
    "wardrobe": {
      "title": "衣橱",
      "equippedContentDescription": "已装备"
    },
    "settings": {
      "title": "虚拟形象设置",
      "privacy": "隐私",
      "privateAvatarMode": "私密虚拟形象模式",
      "privateAvatarDescription": "向其他用户隐藏您的虚拟形象",
      "appearance": "外观",
      "enableAnimations": "启用动画",
      "animationsDescription": "为虚拟形象的动作和表情添加动画",
      "availableOutfits": "可用服装"
    },
    "selfie": {
      "title": "视频自拍",
      "camera": "相机",
      "cameraPreview": "相机预览",
      "startRecording": "开始录制",
      "stopRecording": "停止录制",
      "rec": "REC",
      "enterPin": "输入您的 PIN 以创建虚拟形象",
      "pinLabel": "PIN",
      "retake": "重拍",
      "creatingAvatar": "正在创建您的虚拟形象...",
      "avatarCreated": "虚拟形象创建成功",
      "avatarPreviewContentDescription": "虚拟形象预览",
      "createAnother": "再创建一个"
    },
    "mesh": {
      "title": "3D 虚拟形象",
      "meshViewer": "3D 网格查看器",
      "meshViewerDescription": "3D 网格查看器需要 WebView 或 GLSurfaceView 集成",
      "skinTone": "肤色",
      "hairStyle": "发型",
      "accessories": "配件",
      "saveChanges": "保存更改"
    },
    "v2v": {
      "title": "语音练习",
      "nextPhrase": "下一个短语",
      "stop": "停止",
      "record": "录制",
      "mic": "MIC",
      "viewProgress": "查看进度",
      "analyzingPronunciation": "正在分析发音...",
      "pronunciationFeedback": "发音反馈",
      "similarity": "相似度: {{score}}%",
      "yourProgress": "您的进度",
      "transforms": "变换: {{count}}",
      "improvement": "改进: {{score}}%",
      "continuePracticing": "继续练习"
    },
    "characters": {
      "title": "角色",
      "noCharactersFound": "未找到该电影的角色",
      "characterCount": "{{count}} 个角色"
    },
    "interactions": {
      "title": "电影互动",
      "noInteractableMovies": "没有可互动的电影"
    },
    "feedbackInbox": {
      "title": "反馈收件箱",
      "refreshContentDescription": "刷新",
      "noFeedbackYet": "暂无反馈",
      "feedbackAppearHere": "来自您联系人的反馈将显示在此处",
      "playVoiceMessage": "播放语音消息"
    },
    "addContact": {
      "title": "添加联系人",
      "nameLabel": "名称",
      "phoneLabel": "电话",
      "relationship": "关系",
      "language": "语言"
    },
    "avatar3d": {
      "title": "3D 虚拟形象",
      "glbMeshViewer": "GLB 网格查看器",
      "controls": "控制",
      "animate": "动画",
      "vertices": "顶点",
      "bones": "骨骼",
      "blendShapes": "混合形状",
      "hasGlb": "包含 GLB",
      "status": "状态: {{value}}"
    }
  }
}
